import Icon0Plus from './0Plus';
export { Icon0Plus };

import Icon10Plus from './10Plus';
export { Icon10Plus };

import Icon12Plus from './12Plus';
export { Icon12Plus };

import Icon13Plus from './13Plus';
export { Icon13Plus };

import Icon16Plus from './16Plus';
export { Icon16Plus };

import Icon17Plus from './17Plus';
export { Icon17Plus };

import Icon18Plus from './18Plus';
export { Icon18Plus };

import Icon21Plus from './21Plus';
export { Icon21Plus };

import Icon3Plus from './3Plus';
export { Icon3Plus };

import Icon500Px from './500Px';
export { Icon500Px };

import Icon6Plus from './6Plus';
export { Icon6Plus };

import IconAbacus from './Abacus';
export { IconAbacus };

import IconAccessibleIconAlt from './AccessibleIconAlt';
export { IconAccessibleIconAlt };

import IconAdjustAlt from './AdjustAlt';
export { IconAdjustAlt };

import IconAdjustCircle from './AdjustCircle';
export { IconAdjustCircle };

import IconAdjustHalf from './AdjustHalf';
export { IconAdjustHalf };

import IconAdjust from './Adjust';
export { IconAdjust };

import IconAdobeAlt from './AdobeAlt';
export { IconAdobeAlt };

import IconAdobe from './Adobe';
export { IconAdobe };

import IconAirplay from './Airplay';
export { IconAirplay };

import IconAlignAlt from './AlignAlt';
export { IconAlignAlt };

import IconAlignCenterAlt from './AlignCenterAlt';
export { IconAlignCenterAlt };

import IconAlignCenterH from './AlignCenterH';
export { IconAlignCenterH };

import IconAlignCenterJustify from './AlignCenterJustify';
export { IconAlignCenterJustify };

import IconAlignCenterV from './AlignCenterV';
export { IconAlignCenterV };

import IconAlignCenter from './AlignCenter';
export { IconAlignCenter };

import IconAlignJustify from './AlignJustify';
export { IconAlignJustify };

import IconAlignLeftJustify from './AlignLeftJustify';
export { IconAlignLeftJustify };

import IconAlignLeft from './AlignLeft';
export { IconAlignLeft };

import IconAlignLetterRight from './AlignLetterRight';
export { IconAlignLetterRight };

import IconAlignRightJustify from './AlignRightJustify';
export { IconAlignRightJustify };

import IconAlignRight from './AlignRight';
export { IconAlignRight };

import IconAlign from './Align';
export { IconAlign };

import IconAmazon from './Amazon';
export { IconAmazon };

import IconAmbulance from './Ambulance';
export { IconAmbulance };

import IconAnalysis from './Analysis';
export { IconAnalysis };

import IconAnalytics from './Analytics';
export { IconAnalytics };

import IconAnchor from './Anchor';
export { IconAnchor };

import IconAndroidAlt from './AndroidAlt';
export { IconAndroidAlt };

import IconAndroidPhoneSlash from './AndroidPhoneSlash';
export { IconAndroidPhoneSlash };

import IconAndroid from './Android';
export { IconAndroid };

import IconAngleDoubleDown from './AngleDoubleDown';
export { IconAngleDoubleDown };

import IconAngleDoubleLeft from './AngleDoubleLeft';
export { IconAngleDoubleLeft };

import IconAngleDoubleRight from './AngleDoubleRight';
export { IconAngleDoubleRight };

import IconAngleDoubleUp from './AngleDoubleUp';
export { IconAngleDoubleUp };

import IconAngleDown from './AngleDown';
export { IconAngleDown };

import IconAngleLeftB from './AngleLeftB';
export { IconAngleLeftB };

import IconAngleLeft from './AngleLeft';
export { IconAngleLeft };

import IconAngleRightB from './AngleRightB';
export { IconAngleRightB };

import IconAngleRight from './AngleRight';
export { IconAngleRight };

import IconAngleUp from './AngleUp';
export { IconAngleUp };

import IconAngry from './Angry';
export { IconAngry };

import IconAnkh from './Ankh';
export { IconAnkh };

import IconAnnoyedAlt from './AnnoyedAlt';
export { IconAnnoyedAlt };

import IconAnnoyed from './Annoyed';
export { IconAnnoyed };

import IconAppleAlt from './AppleAlt';
export { IconAppleAlt };

import IconApple from './Apple';
export { IconApple };

import IconApps from './Apps';
export { IconApps };

import IconArchiveAlt from './ArchiveAlt';
export { IconArchiveAlt };

import IconArchive from './Archive';
export { IconArchive };

import IconArchway from './Archway';
export { IconArchway };

import IconArrowBreak from './ArrowBreak';
export { IconArrowBreak };

import IconArrowCircleDown from './ArrowCircleDown';
export { IconArrowCircleDown };

import IconArrowCircleLeft from './ArrowCircleLeft';
export { IconArrowCircleLeft };

import IconArrowCircleRight from './ArrowCircleRight';
export { IconArrowCircleRight };

import IconArrowCircleUp from './ArrowCircleUp';
export { IconArrowCircleUp };

import IconArrowCompressH from './ArrowCompressH';
export { IconArrowCompressH };

import IconArrowDownLeft from './ArrowDownLeft';
export { IconArrowDownLeft };

import IconArrowDownRight from './ArrowDownRight';
export { IconArrowDownRight };

import IconArrowDown from './ArrowDown';
export { IconArrowDown };

import IconArrowFromRight from './ArrowFromRight';
export { IconArrowFromRight };

import IconArrowFromTop from './ArrowFromTop';
export { IconArrowFromTop };

import IconArrowGrowth from './ArrowGrowth';
export { IconArrowGrowth };

import IconArrowLeft from './ArrowLeft';
export { IconArrowLeft };

import IconArrowRandom from './ArrowRandom';
export { IconArrowRandom };

import IconArrowResizeDiagonal from './ArrowResizeDiagonal';
export { IconArrowResizeDiagonal };

import IconArrowRight from './ArrowRight';
export { IconArrowRight };

import IconArrowToBottom from './ArrowToBottom';
export { IconArrowToBottom };

import IconArrowToRight from './ArrowToRight';
export { IconArrowToRight };

import IconArrowUpLeft from './ArrowUpLeft';
export { IconArrowUpLeft };

import IconArrowUpRight from './ArrowUpRight';
export { IconArrowUpRight };

import IconArrowUp from './ArrowUp';
export { IconArrowUp };

import IconArrow from './Arrow';
export { IconArrow };

import IconArrowsHAlt from './ArrowsHAlt';
export { IconArrowsHAlt };

import IconArrowsH from './ArrowsH';
export { IconArrowsH };

import IconArrowsLeftDown from './ArrowsLeftDown';
export { IconArrowsLeftDown };

import IconArrowsMaximize from './ArrowsMaximize';
export { IconArrowsMaximize };

import IconArrowsMerge from './ArrowsMerge';
export { IconArrowsMerge };

import IconArrowsResizeH from './ArrowsResizeH';
export { IconArrowsResizeH };

import IconArrowsResizeV from './ArrowsResizeV';
export { IconArrowsResizeV };

import IconArrowsResize from './ArrowsResize';
export { IconArrowsResize };

import IconArrowsRightDown from './ArrowsRightDown';
export { IconArrowsRightDown };

import IconArrowsShrinkH from './ArrowsShrinkH';
export { IconArrowsShrinkH };

import IconArrowsShrinkV from './ArrowsShrinkV';
export { IconArrowsShrinkV };

import IconArrowsUpRight from './ArrowsUpRight';
export { IconArrowsUpRight };

import IconArrowsVAlt from './ArrowsVAlt';
export { IconArrowsVAlt };

import IconArrowsV from './ArrowsV';
export { IconArrowsV };

import IconAssistiveListeningSystems from './AssistiveListeningSystems';
export { IconAssistiveListeningSystems };

import IconAsterisk from './Asterisk';
export { IconAsterisk };

import IconAt from './At';
export { IconAt };

import IconAtom from './Atom';
export { IconAtom };

import IconAutoFlash from './AutoFlash';
export { IconAutoFlash };

import IconAwardAlt from './AwardAlt';
export { IconAwardAlt };

import IconAward from './Award';
export { IconAward };

import IconBabyCarriage from './BabyCarriage';
export { IconBabyCarriage };

import IconBackpack from './Backpack';
export { IconBackpack };

import IconBackspace from './Backspace';
export { IconBackspace };

import IconBackward from './Backward';
export { IconBackward };

import IconBagAlt from './BagAlt';
export { IconBagAlt };

import IconBagSlash from './BagSlash';
export { IconBagSlash };

import IconBag from './Bag';
export { IconBag };

import IconBalanceScale from './BalanceScale';
export { IconBalanceScale };

import IconBan from './Ban';
export { IconBan };

import IconBandAid from './BandAid';
export { IconBandAid };

import IconBars from './Bars';
export { IconBars };

import IconBaseballBall from './BaseballBall';
export { IconBaseballBall };

import IconBasketballHoop from './BasketballHoop';
export { IconBasketballHoop };

import IconBasketball from './Basketball';
export { IconBasketball };

import IconBath from './Bath';
export { IconBath };

import IconBatteryBolt from './BatteryBolt';
export { IconBatteryBolt };

import IconBatteryEmpty from './BatteryEmpty';
export { IconBatteryEmpty };

import IconBedDouble from './BedDouble';
export { IconBedDouble };

import IconBed from './Bed';
export { IconBed };

import IconBehanceAlt from './BehanceAlt';
export { IconBehanceAlt };

import IconBehance from './Behance';
export { IconBehance };

import IconBellSchool from './BellSchool';
export { IconBellSchool };

import IconBellSlash from './BellSlash';
export { IconBellSlash };

import IconBell from './Bell';
export { IconBell };

import IconBill from './Bill';
export { IconBill };

import IconBing from './Bing';
export { IconBing };

import IconBitcoinAlt from './BitcoinAlt';
export { IconBitcoinAlt };

import IconBitcoinCircle from './BitcoinCircle';
export { IconBitcoinCircle };

import IconBitcoinSign from './BitcoinSign';
export { IconBitcoinSign };

import IconBitcoin from './Bitcoin';
export { IconBitcoin };

import IconBlackBerry from './BlackBerry';
export { IconBlackBerry };

import IconBloggerAlt from './BloggerAlt';
export { IconBloggerAlt };

import IconBlogger from './Blogger';
export { IconBlogger };

import IconBluetoothB from './BluetoothB';
export { IconBluetoothB };

import IconBold from './Bold';
export { IconBold };

import IconBoltAlt from './BoltAlt';
export { IconBoltAlt };

import IconBoltSlash from './BoltSlash';
export { IconBoltSlash };

import IconBolt from './Bolt';
export { IconBolt };

import IconBookAlt from './BookAlt';
export { IconBookAlt };

import IconBookMedical from './BookMedical';
export { IconBookMedical };

import IconBookOpen from './BookOpen';
export { IconBookOpen };

import IconBookReader from './BookReader';
export { IconBookReader };

import IconBook from './Book';
export { IconBook };

import IconBookmarkFull from './BookmarkFull';
export { IconBookmarkFull };

import IconBookmark from './Bookmark';
export { IconBookmark };

import IconBooks from './Books';
export { IconBooks };

import IconBoombox from './Boombox';
export { IconBoombox };

import IconBorderAlt from './BorderAlt';
export { IconBorderAlt };

import IconBorderBottom from './BorderBottom';
export { IconBorderBottom };

import IconBorderClear from './BorderClear';
export { IconBorderClear };

import IconBorderHorizontal from './BorderHorizontal';
export { IconBorderHorizontal };

import IconBorderInner from './BorderInner';
export { IconBorderInner };

import IconBorderLeft from './BorderLeft';
export { IconBorderLeft };

import IconBorderOut from './BorderOut';
export { IconBorderOut };

import IconBorderRight from './BorderRight';
export { IconBorderRight };

import IconBorderTop from './BorderTop';
export { IconBorderTop };

import IconBorderVertical from './BorderVertical';
export { IconBorderVertical };

import IconBowlingBall from './BowlingBall';
export { IconBowlingBall };

import IconBox from './Box';
export { IconBox };

import IconBracketsCurly from './BracketsCurly';
export { IconBracketsCurly };

import IconBrain from './Brain';
export { IconBrain };

import IconBriefcaseAlt from './BriefcaseAlt';
export { IconBriefcaseAlt };

import IconBriefcase from './Briefcase';
export { IconBriefcase };

import IconBright from './Bright';
export { IconBright };

import IconBrightnessEmpty from './BrightnessEmpty';
export { IconBrightnessEmpty };

import IconBrightnessHalf from './BrightnessHalf';
export { IconBrightnessHalf };

import IconBrightnessLow from './BrightnessLow';
export { IconBrightnessLow };

import IconBrightnessMinus from './BrightnessMinus';
export { IconBrightnessMinus };

import IconBrightnessPlus from './BrightnessPlus';
export { IconBrightnessPlus };

import IconBrightness from './Brightness';
export { IconBrightness };

import IconBringBottom from './BringBottom';
export { IconBringBottom };

import IconBringFront from './BringFront';
export { IconBringFront };

import IconBrowser from './Browser';
export { IconBrowser };

import IconBrushAlt from './BrushAlt';
export { IconBrushAlt };

import IconBug from './Bug';
export { IconBug };

import IconBuilding from './Building';
export { IconBuilding };

import IconBullseye from './Bullseye';
export { IconBullseye };

import IconBusAlt from './BusAlt';
export { IconBusAlt };

import IconBusSchool from './BusSchool';
export { IconBusSchool };

import IconBus from './Bus';
export { IconBus };

import IconCalculatorAlt from './CalculatorAlt';
export { IconCalculatorAlt };

import IconCalculator from './Calculator';
export { IconCalculator };

import IconCalendarAlt from './CalendarAlt';
export { IconCalendarAlt };

import IconCalendarSlash from './CalendarSlash';
export { IconCalendarSlash };

import IconCalender from './Calender';
export { IconCalender };

import IconCalling from './Calling';
export { IconCalling };

import IconCameraChange from './CameraChange';
export { IconCameraChange };

import IconCameraPlus from './CameraPlus';
export { IconCameraPlus };

import IconCameraSlash from './CameraSlash';
export { IconCameraSlash };

import IconCamera from './Camera';
export { IconCamera };

import IconCancel from './Cancel';
export { IconCancel };

import IconCapsule from './Capsule';
export { IconCapsule };

import IconCapture from './Capture';
export { IconCapture };

import IconCarSideview from './CarSideview';
export { IconCarSideview };

import IconCarSlash from './CarSlash';
export { IconCarSlash };

import IconCarWash from './CarWash';
export { IconCarWash };

import IconCar from './Car';
export { IconCar };

import IconCardAtm from './CardAtm';
export { IconCardAtm };

import IconCaretRight from './CaretRight';
export { IconCaretRight };

import IconCell from './Cell';
export { IconCell };

import IconCelsius from './Celsius';
export { IconCelsius };

import IconChannelAdd from './ChannelAdd';
export { IconChannelAdd };

import IconChannel from './Channel';
export { IconChannel };

import IconChartBarAlt from './ChartBarAlt';
export { IconChartBarAlt };

import IconChartBar from './ChartBar';
export { IconChartBar };

import IconChartDown from './ChartDown';
export { IconChartDown };

import IconChartGrowthAlt from './ChartGrowthAlt';
export { IconChartGrowthAlt };

import IconChartGrowth from './ChartGrowth';
export { IconChartGrowth };

import IconChartLine from './ChartLine';
export { IconChartLine };

import IconChartPieAlt from './ChartPieAlt';
export { IconChartPieAlt };

import IconChartPie from './ChartPie';
export { IconChartPie };

import IconChart from './Chart';
export { IconChart };

import IconChatBubbleUser from './ChatBubbleUser';
export { IconChatBubbleUser };

import IconChatInfo from './ChatInfo';
export { IconChatInfo };

import IconChat from './Chat';
export { IconChat };

import IconCheckCircle from './CheckCircle';
export { IconCheckCircle };

import IconCheckSquare from './CheckSquare';
export { IconCheckSquare };

import IconCheck from './Check';
export { IconCheck };

import IconCircleLayer from './CircleLayer';
export { IconCircleLayer };

import IconCircle from './Circle';
export { IconCircle };

import IconCircuit from './Circuit';
export { IconCircuit };

import IconClapperBoard from './ClapperBoard';
export { IconClapperBoard };

import IconClinicMedical from './ClinicMedical';
export { IconClinicMedical };

import IconClipboardAlt from './ClipboardAlt';
export { IconClipboardAlt };

import IconClipboardBlank from './ClipboardBlank';
export { IconClipboardBlank };

import IconClipboardNotes from './ClipboardNotes';
export { IconClipboardNotes };

import IconClipboard from './Clipboard';
export { IconClipboard };

import IconClockEight from './ClockEight';
export { IconClockEight };

import IconClockFive from './ClockFive';
export { IconClockFive };

import IconClockNine from './ClockNine';
export { IconClockNine };

import IconClockSeven from './ClockSeven';
export { IconClockSeven };

import IconClockTen from './ClockTen';
export { IconClockTen };

import IconClockThree from './ClockThree';
export { IconClockThree };

import IconClockTwo from './ClockTwo';
export { IconClockTwo };

import IconClock from './Clock';
export { IconClock };

import IconClosedCaptioningSlash from './ClosedCaptioningSlash';
export { IconClosedCaptioningSlash };

import IconClosedCaptioning from './ClosedCaptioning';
export { IconClosedCaptioning };

import IconCloudBlock from './CloudBlock';
export { IconCloudBlock };

import IconCloudBookmark from './CloudBookmark';
export { IconCloudBookmark };

import IconCloudCheck from './CloudCheck';
export { IconCloudCheck };

import IconCloudComputing from './CloudComputing';
export { IconCloudComputing };

import IconCloudDataConnection from './CloudDataConnection';
export { IconCloudDataConnection };

import IconCloudDatabaseTree from './CloudDatabaseTree';
export { IconCloudDatabaseTree };

import IconCloudDownload from './CloudDownload';
export { IconCloudDownload };

import IconCloudDrizzle from './CloudDrizzle';
export { IconCloudDrizzle };

import IconCloudExclamation from './CloudExclamation';
export { IconCloudExclamation };

import IconCloudHail from './CloudHail';
export { IconCloudHail };

import IconCloudHeart from './CloudHeart';
export { IconCloudHeart };

import IconCloudInfo from './CloudInfo';
export { IconCloudInfo };

import IconCloudLock from './CloudLock';
export { IconCloudLock };

import IconCloudMeatball from './CloudMeatball';
export { IconCloudMeatball };

import IconCloudMoonHail from './CloudMoonHail';
export { IconCloudMoonHail };

import IconCloudMoonMeatball from './CloudMoonMeatball';
export { IconCloudMoonMeatball };

import IconCloudMoonRain from './CloudMoonRain';
export { IconCloudMoonRain };

import IconCloudMoonShowers from './CloudMoonShowers';
export { IconCloudMoonShowers };

import IconCloudMoon from './CloudMoon';
export { IconCloudMoon };

import IconCloudQuestion from './CloudQuestion';
export { IconCloudQuestion };

import IconCloudRainSun from './CloudRainSun';
export { IconCloudRainSun };

import IconCloudRain from './CloudRain';
export { IconCloudRain };

import IconCloudRedo from './CloudRedo';
export { IconCloudRedo };

import IconCloudShare from './CloudShare';
export { IconCloudShare };

import IconCloudShield from './CloudShield';
export { IconCloudShield };

import IconCloudShowersAlt from './CloudShowersAlt';
export { IconCloudShowersAlt };

import IconCloudShowersHeavy from './CloudShowersHeavy';
export { IconCloudShowersHeavy };

import IconCloudShowers from './CloudShowers';
export { IconCloudShowers };

import IconCloudSlash from './CloudSlash';
export { IconCloudSlash };

import IconCloudSunHail from './CloudSunHail';
export { IconCloudSunHail };

import IconCloudSunMeatball from './CloudSunMeatball';
export { IconCloudSunMeatball };

import IconCloudSunRainAlt from './CloudSunRainAlt';
export { IconCloudSunRainAlt };

import IconCloudSunRain from './CloudSunRain';
export { IconCloudSunRain };

import IconCloudSunTear from './CloudSunTear';
export { IconCloudSunTear };

import IconCloudSun from './CloudSun';
export { IconCloudSun };

import IconCloudTimes from './CloudTimes';
export { IconCloudTimes };

import IconCloudUnlock from './CloudUnlock';
export { IconCloudUnlock };

import IconCloudUpload from './CloudUpload';
export { IconCloudUpload };

import IconCloudWifi from './CloudWifi';
export { IconCloudWifi };

import IconCloudWind from './CloudWind';
export { IconCloudWind };

import IconCloud from './Cloud';
export { IconCloud };

import IconClouds from './Clouds';
export { IconClouds };

import IconClub from './Club';
export { IconClub };

import IconCodeBranch from './CodeBranch';
export { IconCodeBranch };

import IconCoffee from './Coffee';
export { IconCoffee };

import IconCog from './Cog';
export { IconCog };

import IconCoins from './Coins';
export { IconCoins };

import IconColumns from './Columns';
export { IconColumns };

import IconCommentAdd from './CommentAdd';
export { IconCommentAdd };

import IconCommentAltBlock from './CommentAltBlock';
export { IconCommentAltBlock };

import IconCommentAltChartLines from './CommentAltChartLines';
export { IconCommentAltChartLines };

import IconCommentAltCheck from './CommentAltCheck';
export { IconCommentAltCheck };

import IconCommentAltDots from './CommentAltDots';
export { IconCommentAltDots };

import IconCommentAltDownload from './CommentAltDownload';
export { IconCommentAltDownload };

import IconCommentAltEdit from './CommentAltEdit';
export { IconCommentAltEdit };

import IconCommentAltExclamation from './CommentAltExclamation';
export { IconCommentAltExclamation };

import IconCommentAltHeart from './CommentAltHeart';
export { IconCommentAltHeart };

import IconCommentAltImage from './CommentAltImage';
export { IconCommentAltImage };

import IconCommentAltInfo from './CommentAltInfo';
export { IconCommentAltInfo };

import IconCommentAltLines from './CommentAltLines';
export { IconCommentAltLines };

import IconCommentAltLock from './CommentAltLock';
export { IconCommentAltLock };

import IconCommentAltMedical from './CommentAltMedical';
export { IconCommentAltMedical };

import IconCommentAltMessage from './CommentAltMessage';
export { IconCommentAltMessage };

import IconCommentAltNotes from './CommentAltNotes';
export { IconCommentAltNotes };

import IconCommentAltPlus from './CommentAltPlus';
export { IconCommentAltPlus };

import IconCommentAltQuestion from './CommentAltQuestion';
export { IconCommentAltQuestion };

import IconCommentAltRedo from './CommentAltRedo';
export { IconCommentAltRedo };

import IconCommentAltSearch from './CommentAltSearch';
export { IconCommentAltSearch };

import IconCommentAltShare from './CommentAltShare';
export { IconCommentAltShare };

import IconCommentAltShield from './CommentAltShield';
export { IconCommentAltShield };

import IconCommentAltSlash from './CommentAltSlash';
export { IconCommentAltSlash };

import IconCommentAltUpload from './CommentAltUpload';
export { IconCommentAltUpload };

import IconCommentAltVerify from './CommentAltVerify';
export { IconCommentAltVerify };

import IconCommentAlt from './CommentAlt';
export { IconCommentAlt };

import IconCommentBlock from './CommentBlock';
export { IconCommentBlock };

import IconCommentChartLine from './CommentChartLine';
export { IconCommentChartLine };

import IconCommentCheck from './CommentCheck';
export { IconCommentCheck };

import IconCommentDots from './CommentDots';
export { IconCommentDots };

import IconCommentDownload from './CommentDownload';
export { IconCommentDownload };

import IconCommentEdit from './CommentEdit';
export { IconCommentEdit };

import IconCommentExclamation from './CommentExclamation';
export { IconCommentExclamation };

import IconCommentHeart from './CommentHeart';
export { IconCommentHeart };

import IconCommentImage from './CommentImage';
export { IconCommentImage };

import IconCommentInfoAlt from './CommentInfoAlt';
export { IconCommentInfoAlt };

import IconCommentInfo from './CommentInfo';
export { IconCommentInfo };

import IconCommentLines from './CommentLines';
export { IconCommentLines };

import IconCommentLock from './CommentLock';
export { IconCommentLock };

import IconCommentMedical from './CommentMedical';
export { IconCommentMedical };

import IconCommentMessage from './CommentMessage';
export { IconCommentMessage };

import IconCommentNotes from './CommentNotes';
export { IconCommentNotes };

import IconCommentPlus from './CommentPlus';
export { IconCommentPlus };

import IconCommentQuestion from './CommentQuestion';
export { IconCommentQuestion };

import IconCommentRedo from './CommentRedo';
export { IconCommentRedo };

import IconCommentSearch from './CommentSearch';
export { IconCommentSearch };

import IconCommentShare from './CommentShare';
export { IconCommentShare };

import IconCommentShield from './CommentShield';
export { IconCommentShield };

import IconCommentSlash from './CommentSlash';
export { IconCommentSlash };

import IconCommentUpload from './CommentUpload';
export { IconCommentUpload };

import IconCommentVerify from './CommentVerify';
export { IconCommentVerify };

import IconComment from './Comment';
export { IconComment };

import IconCommentsAlt from './CommentsAlt';
export { IconCommentsAlt };

import IconComments from './Comments';
export { IconComments };

import IconCompactDisc from './CompactDisc';
export { IconCompactDisc };

import IconComparison from './Comparison';
export { IconComparison };

import IconCompass from './Compass';
export { IconCompass };

import IconCompressAltLeft from './CompressAltLeft';
export { IconCompressAltLeft };

import IconCompressAlt from './CompressAlt';
export { IconCompressAlt };

import IconCompressArrows from './CompressArrows';
export { IconCompressArrows };

import IconCompressLines from './CompressLines';
export { IconCompressLines };

import IconCompressPoint from './CompressPoint';
export { IconCompressPoint };

import IconCompressV from './CompressV';
export { IconCompressV };

import IconCompress from './Compress';
export { IconCompress };

import IconConfused from './Confused';
export { IconConfused };

import IconConstructor from './Constructor';
export { IconConstructor };

import IconCopyAlt from './CopyAlt';
export { IconCopyAlt };

import IconCopyLandscape from './CopyLandscape';
export { IconCopyLandscape };

import IconCopy from './Copy';
export { IconCopy };

import IconCopyright from './Copyright';
export { IconCopyright };

import IconCornerDownLeft from './CornerDownLeft';
export { IconCornerDownLeft };

import IconCornerDownRightAlt from './CornerDownRightAlt';
export { IconCornerDownRightAlt };

import IconCornerDownRight from './CornerDownRight';
export { IconCornerDownRight };

import IconCornerLeftDown from './CornerLeftDown';
export { IconCornerLeftDown };

import IconCornerRightDown from './CornerRightDown';
export { IconCornerRightDown };

import IconCornerUpLeftAlt from './CornerUpLeftAlt';
export { IconCornerUpLeftAlt };

import IconCornerUpLeft from './CornerUpLeft';
export { IconCornerUpLeft };

import IconCornerUpRightAlt from './CornerUpRightAlt';
export { IconCornerUpRightAlt };

import IconCornerUpRight from './CornerUpRight';
export { IconCornerUpRight };

import IconCoronavirus from './Coronavirus';
export { IconCoronavirus };

import IconCreateDashboard from './CreateDashboard';
export { IconCreateDashboard };

import IconCreativeCommonsPd from './CreativeCommonsPd';
export { IconCreativeCommonsPd };

import IconCreditCardSearch from './CreditCardSearch';
export { IconCreditCardSearch };

import IconCreditCard from './CreditCard';
export { IconCreditCard };

import IconCrockery from './Crockery';
export { IconCrockery };

import IconCropAltRotateLeft from './CropAltRotateLeft';
export { IconCropAltRotateLeft };

import IconCropAltRotateRight from './CropAltRotateRight';
export { IconCropAltRotateRight };

import IconCropAlt from './CropAlt';
export { IconCropAlt };

import IconCrosshairAlt from './CrosshairAlt';
export { IconCrosshairAlt };

import IconCrosshair from './Crosshair';
export { IconCrosshair };

import IconCrosshairs from './Crosshairs';
export { IconCrosshairs };

import IconCss3Simple from './Css3Simple';
export { IconCss3Simple };

import IconCube from './Cube';
export { IconCube };

import IconDashboard from './Dashboard';
export { IconDashboard };

import IconDataSharing from './DataSharing';
export { IconDataSharing };

import IconDatabaseAlt from './DatabaseAlt';
export { IconDatabaseAlt };

import IconDatabase from './Database';
export { IconDatabase };

import IconDesert from './Desert';
export { IconDesert };

import IconDesktopAltSlash from './DesktopAltSlash';
export { IconDesktopAltSlash };

import IconDesktopAlt from './DesktopAlt';
export { IconDesktopAlt };

import IconDesktopCloudAlt from './DesktopCloudAlt';
export { IconDesktopCloudAlt };

import IconDesktopSlash from './DesktopSlash';
export { IconDesktopSlash };

import IconDesktop from './Desktop';
export { IconDesktop };

import IconDialpadAlt from './DialpadAlt';
export { IconDialpadAlt };

import IconDialpad from './Dialpad';
export { IconDialpad };

import IconDiamond from './Diamond';
export { IconDiamond };

import IconDiaryAlt from './DiaryAlt';
export { IconDiaryAlt };

import IconDiary from './Diary';
export { IconDiary };

import IconDiceFive from './DiceFive';
export { IconDiceFive };

import IconDiceFour from './DiceFour';
export { IconDiceFour };

import IconDiceOne from './DiceOne';
export { IconDiceOne };

import IconDiceSix from './DiceSix';
export { IconDiceSix };

import IconDiceThree from './DiceThree';
export { IconDiceThree };

import IconDiceTwo from './DiceTwo';
export { IconDiceTwo };

import IconDirection from './Direction';
export { IconDirection };

import IconDirections from './Directions';
export { IconDirections };

import IconDiscord from './Discord';
export { IconDiscord };

import IconDizzyMeh from './DizzyMeh';
export { IconDizzyMeh };

import IconDna from './Dna';
export { IconDna };

import IconDocker from './Docker';
export { IconDocker };

import IconDocumentInfo from './DocumentInfo';
export { IconDocumentInfo };

import IconDocumentLayoutCenter from './DocumentLayoutCenter';
export { IconDocumentLayoutCenter };

import IconDocumentLayoutLeft from './DocumentLayoutLeft';
export { IconDocumentLayoutLeft };

import IconDocumentLayoutRight from './DocumentLayoutRight';
export { IconDocumentLayoutRight };

import IconDollarAlt from './DollarAlt';
export { IconDollarAlt };

import IconDollarSignAlt from './DollarSignAlt';
export { IconDollarSignAlt };

import IconDollarSign from './DollarSign';
export { IconDollarSign };

import IconDownloadAlt from './DownloadAlt';
export { IconDownloadAlt };

import IconDraggabledots from './Draggabledots';
export { IconDraggabledots };

import IconDribbble from './Dribbble';
export { IconDribbble };

import IconDrill from './Drill';
export { IconDrill };

import IconDropbox from './Dropbox';
export { IconDropbox };

import IconDumbbell from './Dumbbell';
export { IconDumbbell };

import IconEar from './Ear';
export { IconEar };

import IconEditAlt from './EditAlt';
export { IconEditAlt };

import IconEdit from './Edit';
export { IconEdit };

import IconElipsisDoubleVAlt from './ElipsisDoubleVAlt';
export { IconElipsisDoubleVAlt };

import IconEllipsisH from './EllipsisH';
export { IconEllipsisH };

import IconEllipsisV from './EllipsisV';
export { IconEllipsisV };

import IconEmoji from './Emoji';
export { IconEmoji };

import IconEnglishToChinese from './EnglishToChinese';
export { IconEnglishToChinese };

import IconEnter from './Enter';
export { IconEnter };

import IconEnvelopeAdd from './EnvelopeAdd';
export { IconEnvelopeAdd };

import IconEnvelopeAlt from './EnvelopeAlt';
export { IconEnvelopeAlt };

import IconEnvelopeBlock from './EnvelopeBlock';
export { IconEnvelopeBlock };

import IconEnvelopeBookmark from './EnvelopeBookmark';
export { IconEnvelopeBookmark };

import IconEnvelopeCheck from './EnvelopeCheck';
export { IconEnvelopeCheck };

import IconEnvelopeDownloadAlt from './EnvelopeDownloadAlt';
export { IconEnvelopeDownloadAlt };

import IconEnvelopeDownload from './EnvelopeDownload';
export { IconEnvelopeDownload };

import IconEnvelopeEdit from './EnvelopeEdit';
export { IconEnvelopeEdit };

import IconEnvelopeExclamation from './EnvelopeExclamation';
export { IconEnvelopeExclamation };

import IconEnvelopeHeart from './EnvelopeHeart';
export { IconEnvelopeHeart };

import IconEnvelopeInfo from './EnvelopeInfo';
export { IconEnvelopeInfo };

import IconEnvelopeLock from './EnvelopeLock';
export { IconEnvelopeLock };

import IconEnvelopeMinus from './EnvelopeMinus';
export { IconEnvelopeMinus };

import IconEnvelopeOpen from './EnvelopeOpen';
export { IconEnvelopeOpen };

import IconEnvelopeQuestion from './EnvelopeQuestion';
export { IconEnvelopeQuestion };

import IconEnvelopeReceive from './EnvelopeReceive';
export { IconEnvelopeReceive };

import IconEnvelopeRedo from './EnvelopeRedo';
export { IconEnvelopeRedo };

import IconEnvelopeSearch from './EnvelopeSearch';
export { IconEnvelopeSearch };

import IconEnvelopeSend from './EnvelopeSend';
export { IconEnvelopeSend };

import IconEnvelopeShare from './EnvelopeShare';
export { IconEnvelopeShare };

import IconEnvelopeShield from './EnvelopeShield';
export { IconEnvelopeShield };

import IconEnvelopeStar from './EnvelopeStar';
export { IconEnvelopeStar };

import IconEnvelopeTimes from './EnvelopeTimes';
export { IconEnvelopeTimes };

import IconEnvelopeUploadAlt from './EnvelopeUploadAlt';
export { IconEnvelopeUploadAlt };

import IconEnvelopeUpload from './EnvelopeUpload';
export { IconEnvelopeUpload };

import IconEnvelope from './Envelope';
export { IconEnvelope };

import IconEnvelopes from './Envelopes';
export { IconEnvelopes };

import IconEqualCircle from './EqualCircle';
export { IconEqualCircle };

import IconEstate from './Estate';
export { IconEstate };

import IconEuroCircle from './EuroCircle';
export { IconEuroCircle };

import IconEuro from './Euro';
export { IconEuro };

import IconExchangeAlt from './ExchangeAlt';
export { IconExchangeAlt };

import IconExchange from './Exchange';
export { IconExchange };

import IconExclamationCircle from './ExclamationCircle';
export { IconExclamationCircle };

import IconExclamationOctagon from './ExclamationOctagon';
export { IconExclamationOctagon };

import IconExclamationTriangle from './ExclamationTriangle';
export { IconExclamationTriangle };

import IconExclamation from './Exclamation';
export { IconExclamation };

import IconExclude from './Exclude';
export { IconExclude };

import IconExit from './Exit';
export { IconExit };

import IconExpandAlt from './ExpandAlt';
export { IconExpandAlt };

import IconExpandArrowsAlt from './ExpandArrowsAlt';
export { IconExpandArrowsAlt };

import IconExpandArrows from './ExpandArrows';
export { IconExpandArrows };

import IconExpandFromCorner from './ExpandFromCorner';
export { IconExpandFromCorner };

import IconExpandLeft from './ExpandLeft';
export { IconExpandLeft };

import IconExpandRight from './ExpandRight';
export { IconExpandRight };

import IconExport from './Export';
export { IconExport };

import IconExposureAlt from './ExposureAlt';
export { IconExposureAlt };

import IconExposureIncrease from './ExposureIncrease';
export { IconExposureIncrease };

import IconExternalLinkAlt from './ExternalLinkAlt';
export { IconExternalLinkAlt };

import IconEyeSlash from './EyeSlash';
export { IconEyeSlash };

import IconEye from './Eye';
export { IconEye };

import IconFacebookF from './FacebookF';
export { IconFacebookF };

import IconFacebookMessengerAlt from './FacebookMessengerAlt';
export { IconFacebookMessengerAlt };

import IconFacebookMessenger from './FacebookMessenger';
export { IconFacebookMessenger };

import IconFacebook from './Facebook';
export { IconFacebook };

import IconFahrenheit from './Fahrenheit';
export { IconFahrenheit };

import IconFastMailAlt from './FastMailAlt';
export { IconFastMailAlt };

import IconFastMail from './FastMail';
export { IconFastMail };

import IconFavorite from './Favorite';
export { IconFavorite };

import IconFeedback from './Feedback';
export { IconFeedback };

import IconFidgetSpinner from './FidgetSpinner';
export { IconFidgetSpinner };

import IconFileAlt from './FileAlt';
export { IconFileAlt };

import IconFileBlank from './FileBlank';
export { IconFileBlank };

import IconFileBlockAlt from './FileBlockAlt';
export { IconFileBlockAlt };

import IconFileBookmarkAlt from './FileBookmarkAlt';
export { IconFileBookmarkAlt };

import IconFileCheckAlt from './FileCheckAlt';
export { IconFileCheckAlt };

import IconFileCheck from './FileCheck';
export { IconFileCheck };

import IconFileContractDollar from './FileContractDollar';
export { IconFileContractDollar };

import IconFileContract from './FileContract';
export { IconFileContract };

import IconFileCopyAlt from './FileCopyAlt';
export { IconFileCopyAlt };

import IconFileDownloadAlt from './FileDownloadAlt';
export { IconFileDownloadAlt };

import IconFileDownload from './FileDownload';
export { IconFileDownload };

import IconFileEditAlt from './FileEditAlt';
export { IconFileEditAlt };

import IconFileExclamationAlt from './FileExclamationAlt';
export { IconFileExclamationAlt };

import IconFileExclamation from './FileExclamation';
export { IconFileExclamation };

import IconFileExport from './FileExport';
export { IconFileExport };

import IconFileGraph from './FileGraph';
export { IconFileGraph };

import IconFileHeart from './FileHeart';
export { IconFileHeart };

import IconFileImport from './FileImport';
export { IconFileImport };

import IconFileInfoAlt from './FileInfoAlt';
export { IconFileInfoAlt };

import IconFileLandscapeAlt from './FileLandscapeAlt';
export { IconFileLandscapeAlt };

import IconFileLandscape from './FileLandscape';
export { IconFileLandscape };

import IconFileLanscapeSlash from './FileLanscapeSlash';
export { IconFileLanscapeSlash };

import IconFileLockAlt from './FileLockAlt';
export { IconFileLockAlt };

import IconFileMedicalAlt from './FileMedicalAlt';
export { IconFileMedicalAlt };

import IconFileMedical from './FileMedical';
export { IconFileMedical };

import IconFileMinusAlt from './FileMinusAlt';
export { IconFileMinusAlt };

import IconFileMinus from './FileMinus';
export { IconFileMinus };

import IconFileNetwork from './FileNetwork';
export { IconFileNetwork };

import IconFilePlusAlt from './FilePlusAlt';
export { IconFilePlusAlt };

import IconFilePlus from './FilePlus';
export { IconFilePlus };

import IconFileQuestionAlt from './FileQuestionAlt';
export { IconFileQuestionAlt };

import IconFileQuestion from './FileQuestion';
export { IconFileQuestion };

import IconFileRedoAlt from './FileRedoAlt';
export { IconFileRedoAlt };

import IconFileSearchAlt from './FileSearchAlt';
export { IconFileSearchAlt };

import IconFileShareAlt from './FileShareAlt';
export { IconFileShareAlt };

import IconFileShieldAlt from './FileShieldAlt';
export { IconFileShieldAlt };

import IconFileSlash from './FileSlash';
export { IconFileSlash };

import IconFileTimesAlt from './FileTimesAlt';
export { IconFileTimesAlt };

import IconFileTimes from './FileTimes';
export { IconFileTimes };

import IconFileUploadAlt from './FileUploadAlt';
export { IconFileUploadAlt };

import IconFileUpload from './FileUpload';
export { IconFileUpload };

import IconFile from './File';
export { IconFile };

import IconFilesLandscapesAlt from './FilesLandscapesAlt';
export { IconFilesLandscapesAlt };

import IconFilesLandscapes from './FilesLandscapes';
export { IconFilesLandscapes };

import IconFilm from './Film';
export { IconFilm };

import IconFilterSlash from './FilterSlash';
export { IconFilterSlash };

import IconFilter from './Filter';
export { IconFilter };

import IconFire from './Fire';
export { IconFire };

import IconFlaskPotion from './FlaskPotion';
export { IconFlaskPotion };

import IconFlask from './Flask';
export { IconFlask };

import IconFlipHAlt from './FlipHAlt';
export { IconFlipHAlt };

import IconFlipH from './FlipH';
export { IconFlipH };

import IconFlipVAlt from './FlipVAlt';
export { IconFlipVAlt };

import IconFlipV from './FlipV';
export { IconFlipV };

import IconFlower from './Flower';
export { IconFlower };

import IconFocusAdd from './FocusAdd';
export { IconFocusAdd };

import IconFocusTarget from './FocusTarget';
export { IconFocusTarget };

import IconFocus from './Focus';
export { IconFocus };

import IconFolderCheck from './FolderCheck';
export { IconFolderCheck };

import IconFolderDownload from './FolderDownload';
export { IconFolderDownload };

import IconFolderExclamation from './FolderExclamation';
export { IconFolderExclamation };

import IconFolderHeart from './FolderHeart';
export { IconFolderHeart };

import IconFolderInfo from './FolderInfo';
export { IconFolderInfo };

import IconFolderLock from './FolderLock';
export { IconFolderLock };

import IconFolderMedical from './FolderMedical';
export { IconFolderMedical };

import IconFolderMinus from './FolderMinus';
export { IconFolderMinus };

import IconFolderNetwork from './FolderNetwork';
export { IconFolderNetwork };

import IconFolderOpen from './FolderOpen';
export { IconFolderOpen };

import IconFolderPlus from './FolderPlus';
export { IconFolderPlus };

import IconFolderQuestion from './FolderQuestion';
export { IconFolderQuestion };

import IconFolderSlash from './FolderSlash';
export { IconFolderSlash };

import IconFolderTimes from './FolderTimes';
export { IconFolderTimes };

import IconFolderUpload from './FolderUpload';
export { IconFolderUpload };

import IconFolder from './Folder';
export { IconFolder };

import IconFont from './Font';
export { IconFont };

import IconFootballAmerican from './FootballAmerican';
export { IconFootballAmerican };

import IconFootballBall from './FootballBall';
export { IconFootballBall };

import IconFootball from './Football';
export { IconFootball };

import IconForecastcloudMoonTear from './ForecastcloudMoonTear';
export { IconForecastcloudMoonTear };

import IconForwadedCall from './ForwadedCall';
export { IconForwadedCall };

import IconForward from './Forward';
export { IconForward };

import IconFrown from './Frown';
export { IconFrown };

import IconGameStructure from './GameStructure';
export { IconGameStructure };

import IconGift from './Gift';
export { IconGift };

import IconGithubAlt from './GithubAlt';
export { IconGithubAlt };

import IconGithub from './Github';
export { IconGithub };

import IconGitlab from './Gitlab';
export { IconGitlab };

import IconGlassMartiniAltSlash from './GlassMartiniAltSlash';
export { IconGlassMartiniAltSlash };

import IconGlassMartiniAlt from './GlassMartiniAlt';
export { IconGlassMartiniAlt };

import IconGlassMartini from './GlassMartini';
export { IconGlassMartini };

import IconGlassTea from './GlassTea';
export { IconGlassTea };

import IconGlass from './Glass';
export { IconGlass };

import IconGlobe from './Globe';
export { IconGlobe };

import IconGold from './Gold';
export { IconGold };

import IconGolfBall from './GolfBall';
export { IconGolfBall };

import IconGoogleDriveAlt from './GoogleDriveAlt';
export { IconGoogleDriveAlt };

import IconGoogleDrive from './GoogleDrive';
export { IconGoogleDrive };

import IconGoogleHangoutsAlt from './GoogleHangoutsAlt';
export { IconGoogleHangoutsAlt };

import IconGoogleHangouts from './GoogleHangouts';
export { IconGoogleHangouts };

import IconGooglePlay from './GooglePlay';
export { IconGooglePlay };

import IconGoogle from './Google';
export { IconGoogle };

import IconGraduationCap from './GraduationCap';
export { IconGraduationCap };

import IconGraphBar from './GraphBar';
export { IconGraphBar };

import IconGrid from './Grid';
export { IconGrid };

import IconGrids from './Grids';
export { IconGrids };

import IconGrinTongueWinkAlt from './GrinTongueWinkAlt';
export { IconGrinTongueWinkAlt };

import IconGrinTongueWink from './GrinTongueWink';
export { IconGrinTongueWink };

import IconGrin from './Grin';
export { IconGrin };

import IconGripHorizontalLine from './GripHorizontalLine';
export { IconGripHorizontalLine };

import IconHardHat from './HardHat';
export { IconHardHat };

import IconHdd from './Hdd';
export { IconHdd };

import IconHeadSideCough from './HeadSideCough';
export { IconHeadSideCough };

import IconHeadSideMask from './HeadSideMask';
export { IconHeadSideMask };

import IconHeadSide from './HeadSide';
export { IconHeadSide };

import IconHeadphoneSlash from './HeadphoneSlash';
export { IconHeadphoneSlash };

import IconHeadphonesAlt from './HeadphonesAlt';
export { IconHeadphonesAlt };

import IconHeadphones from './Headphones';
export { IconHeadphones };

import IconHeartAlt from './HeartAlt';
export { IconHeartAlt };

import IconHeartBreak from './HeartBreak';
export { IconHeartBreak };

import IconHeartMedical from './HeartMedical';
export { IconHeartMedical };

import IconHeartRate from './HeartRate';
export { IconHeartRate };

import IconHeartSign from './HeartSign';
export { IconHeartSign };

import IconHeart from './Heart';
export { IconHeart };

import IconHeartbeat from './Heartbeat';
export { IconHeartbeat };

import IconHindiToChinese from './HindiToChinese';
export { IconHindiToChinese };

import IconHipchat from './Hipchat';
export { IconHipchat };

import IconHistoryAlt from './HistoryAlt';
export { IconHistoryAlt };

import IconHistory from './History';
export { IconHistory };

import IconHomeAlt from './HomeAlt';
export { IconHomeAlt };

import IconHome from './Home';
export { IconHome };

import IconHorizontalAlignCenter from './HorizontalAlignCenter';
export { IconHorizontalAlignCenter };

import IconHorizontalAlignLeft from './HorizontalAlignLeft';
export { IconHorizontalAlignLeft };

import IconHorizontalAlignRight from './HorizontalAlignRight';
export { IconHorizontalAlignRight };

import IconHorizontalDistributionCenter from './HorizontalDistributionCenter';
export { IconHorizontalDistributionCenter };

import IconHorizontalDistributionLeft from './HorizontalDistributionLeft';
export { IconHorizontalDistributionLeft };

import IconHorizontalDistributionRight from './HorizontalDistributionRight';
export { IconHorizontalDistributionRight };

import IconHospitalSquareSign from './HospitalSquareSign';
export { IconHospitalSquareSign };

import IconHospitalSymbol from './HospitalSymbol';
export { IconHospitalSymbol };

import IconHospital from './Hospital';
export { IconHospital };

import IconHourglass from './Hourglass';
export { IconHourglass };

import IconHouseUser from './HouseUser';
export { IconHouseUser };

import IconHtml3Alt from './Html3Alt';
export { IconHtml3Alt };

import IconHtml3 from './Html3';
export { IconHtml3 };

import IconHtml5Alt from './Html5Alt';
export { IconHtml5Alt };

import IconHtml5 from './Html5';
export { IconHtml5 };

import IconHunting from './Hunting';
export { IconHunting };

import IconIcons from './Icons';
export { IconIcons };

import IconIllustration from './Illustration';
export { IconIllustration };

import IconImageAltSlash from './ImageAltSlash';
export { IconImageAltSlash };

import IconImageBlock from './ImageBlock';
export { IconImageBlock };

import IconImageBroken from './ImageBroken';
export { IconImageBroken };

import IconImageCheck from './ImageCheck';
export { IconImageCheck };

import IconImageDownload from './ImageDownload';
export { IconImageDownload };

import IconImageEdit from './ImageEdit';
export { IconImageEdit };

import IconImageLock from './ImageLock';
export { IconImageLock };

import IconImageMinus from './ImageMinus';
export { IconImageMinus };

import IconImagePlus from './ImagePlus';
export { IconImagePlus };

import IconImageQuestion from './ImageQuestion';
export { IconImageQuestion };

import IconImageRedo from './ImageRedo';
export { IconImageRedo };

import IconImageResizeLandscape from './ImageResizeLandscape';
export { IconImageResizeLandscape };

import IconImageResizeSquare from './ImageResizeSquare';
export { IconImageResizeSquare };

import IconImageSearch from './ImageSearch';
export { IconImageSearch };

import IconImageShare from './ImageShare';
export { IconImageShare };

import IconImageShield from './ImageShield';
export { IconImageShield };

import IconImageSlash from './ImageSlash';
export { IconImageSlash };

import IconImageTimes from './ImageTimes';
export { IconImageTimes };

import IconImageUpload from './ImageUpload';
export { IconImageUpload };

import IconImageV from './ImageV';
export { IconImageV };

import IconImage from './Image';
export { IconImage };

import IconImages from './Images';
export { IconImages };

import IconImport from './Import';
export { IconImport };

import IconInbox from './Inbox';
export { IconInbox };

import IconIncomingCall from './IncomingCall';
export { IconIncomingCall };

import IconInfoCircle from './InfoCircle';
export { IconInfoCircle };

import IconInfo from './Info';
export { IconInfo };

import IconInstagramAlt from './InstagramAlt';
export { IconInstagramAlt };

import IconInstagram from './Instagram';
export { IconInstagram };

import IconIntercomAlt from './IntercomAlt';
export { IconIntercomAlt };

import IconIntercom from './Intercom';
export { IconIntercom };

import IconInvoice from './Invoice';
export { IconInvoice };

import IconItalic from './Italic';
export { IconItalic };

import IconJackhammer from './Jackhammer';
export { IconJackhammer };

import IconJavaScript from './JavaScript';
export { IconJavaScript };

import IconKayak from './Kayak';
export { IconKayak };

import IconKeySkeletonAlt from './KeySkeletonAlt';
export { IconKeySkeletonAlt };

import IconKeySkeleton from './KeySkeleton';
export { IconKeySkeleton };

import IconKeyboardAlt from './KeyboardAlt';
export { IconKeyboardAlt };

import IconKeyboardHide from './KeyboardHide';
export { IconKeyboardHide };

import IconKeyboardShow from './KeyboardShow';
export { IconKeyboardShow };

import IconKeyboard from './Keyboard';
export { IconKeyboard };

import IconKeyholeCircle from './KeyholeCircle';
export { IconKeyholeCircle };

import IconKeyholeSquareFull from './KeyholeSquareFull';
export { IconKeyholeSquareFull };

import IconKeyholeSquare from './KeyholeSquare';
export { IconKeyholeSquare };

import IconKid from './Kid';
export { IconKid };

import IconLabelAlt from './LabelAlt';
export { IconLabelAlt };

import IconLabel from './Label';
export { IconLabel };

import IconLamp from './Lamp';
export { IconLamp };

import IconLanguage from './Language';
export { IconLanguage };

import IconLaptopCloud from './LaptopCloud';
export { IconLaptopCloud };

import IconLaptopConnection from './LaptopConnection';
export { IconLaptopConnection };

import IconLaptop from './Laptop';
export { IconLaptop };

import IconLaughing from './Laughing';
export { IconLaughing };

import IconLayerGroupSlash from './LayerGroupSlash';
export { IconLayerGroupSlash };

import IconLayerGroup from './LayerGroup';
export { IconLayerGroup };

import IconLayersAlt from './LayersAlt';
export { IconLayersAlt };

import IconLayersSlash from './LayersSlash';
export { IconLayersSlash };

import IconLayers from './Layers';
export { IconLayers };

import IconLeftArrowFromLeft from './LeftArrowFromLeft';
export { IconLeftArrowFromLeft };

import IconLeftArrowToLeft from './LeftArrowToLeft';
export { IconLeftArrowToLeft };

import IconLeftIndentAlt from './LeftIndentAlt';
export { IconLeftIndentAlt };

import IconLeftIndent from './LeftIndent';
export { IconLeftIndent };

import IconLeftToRightTextDirection from './LeftToRightTextDirection';
export { IconLeftToRightTextDirection };

import IconLetterChineseA from './LetterChineseA';
export { IconLetterChineseA };

import IconLetterEnglishA from './LetterEnglishA';
export { IconLetterEnglishA };

import IconLetterHindiA from './LetterHindiA';
export { IconLetterHindiA };

import IconLetterJapaneseA from './LetterJapaneseA';
export { IconLetterJapaneseA };

import IconLifeRing from './LifeRing';
export { IconLifeRing };

import IconLightbulbAlt from './LightbulbAlt';
export { IconLightbulbAlt };

import IconLightbulb from './Lightbulb';
export { IconLightbulb };

import IconLineAlt from './LineAlt';
export { IconLineAlt };

import IconLineSpacing from './LineSpacing';
export { IconLineSpacing };

import IconLine from './Line';
export { IconLine };

import IconLinkAdd from './LinkAdd';
export { IconLinkAdd };

import IconLinkAlt from './LinkAlt';
export { IconLinkAlt };

import IconLinkBroken from './LinkBroken';
export { IconLinkBroken };

import IconLinkH from './LinkH';
export { IconLinkH };

import IconLink from './Link';
export { IconLink };

import IconLinkedinAlt from './LinkedinAlt';
export { IconLinkedinAlt };

import IconLinkedin from './Linkedin';
export { IconLinkedin };

import IconLinux from './Linux';
export { IconLinux };

import IconLiraSign from './LiraSign';
export { IconLiraSign };

import IconListOlAlt from './ListOlAlt';
export { IconListOlAlt };

import IconListOl from './ListOl';
export { IconListOl };

import IconListUiAlt from './ListUiAlt';
export { IconListUiAlt };

import IconListUl from './ListUl';
export { IconListUl };

import IconLocationArrowAlt from './LocationArrowAlt';
export { IconLocationArrowAlt };

import IconLocationArrow from './LocationArrow';
export { IconLocationArrow };

import IconLocationPinAlt from './LocationPinAlt';
export { IconLocationPinAlt };

import IconLocationPoint from './LocationPoint';
export { IconLocationPoint };

import IconLockAccess from './LockAccess';
export { IconLockAccess };

import IconLockAlt from './LockAlt';
export { IconLockAlt };

import IconLockOpenAlt from './LockOpenAlt';
export { IconLockOpenAlt };

import IconLockSlash from './LockSlash';
export { IconLockSlash };

import IconLock from './Lock';
export { IconLock };

import IconLottiefilesAlt from './LottiefilesAlt';
export { IconLottiefilesAlt };

import IconLottiefiles from './Lottiefiles';
export { IconLottiefiles };

import IconLuggageCart from './LuggageCart';
export { IconLuggageCart };

import IconMailboxAlt from './MailboxAlt';
export { IconMailboxAlt };

import IconMailbox from './Mailbox';
export { IconMailbox };

import IconMapMarkerAlt from './MapMarkerAlt';
export { IconMapMarkerAlt };

import IconMapMarkerEdit from './MapMarkerEdit';
export { IconMapMarkerEdit };

import IconMapMarkerInfo from './MapMarkerInfo';
export { IconMapMarkerInfo };

import IconMapMarkerMinus from './MapMarkerMinus';
export { IconMapMarkerMinus };

import IconMapMarkerPlus from './MapMarkerPlus';
export { IconMapMarkerPlus };

import IconMapMarkerQuestion from './MapMarkerQuestion';
export { IconMapMarkerQuestion };

import IconMapMarkerShield from './MapMarkerShield';
export { IconMapMarkerShield };

import IconMapMarkerSlash from './MapMarkerSlash';
export { IconMapMarkerSlash };

import IconMapMarker from './MapMarker';
export { IconMapMarker };

import IconMapPinAlt from './MapPinAlt';
export { IconMapPinAlt };

import IconMapPin from './MapPin';
export { IconMapPin };

import IconMap from './Map';
export { IconMap };

import IconMars from './Mars';
export { IconMars };

import IconMasterCard from './MasterCard';
export { IconMasterCard };

import IconMaximizeLeft from './MaximizeLeft';
export { IconMaximizeLeft };

import IconMedal from './Medal';
export { IconMedal };

import IconMedicalDrip from './MedicalDrip';
export { IconMedicalDrip };

import IconMedicalSquareFull from './MedicalSquareFull';
export { IconMedicalSquareFull };

import IconMedicalSquare from './MedicalSquare';
export { IconMedicalSquare };

import IconMediumM from './MediumM';
export { IconMediumM };

import IconMedkit from './Medkit';
export { IconMedkit };

import IconMeetingBoard from './MeetingBoard';
export { IconMeetingBoard };

import IconMegaphone from './Megaphone';
export { IconMegaphone };

import IconMehAlt from './MehAlt';
export { IconMehAlt };

import IconMehClosedEye from './MehClosedEye';
export { IconMehClosedEye };

import IconMeh from './Meh';
export { IconMeh };

import IconMessage from './Message';
export { IconMessage };

import IconMetro from './Metro';
export { IconMetro };

import IconMicrophoneSlash from './MicrophoneSlash';
export { IconMicrophoneSlash };

import IconMicrophone from './Microphone';
export { IconMicrophone };

import IconMicroscope from './Microscope';
export { IconMicroscope };

import IconMicrosoft from './Microsoft';
export { IconMicrosoft };

import IconMinusCircle from './MinusCircle';
export { IconMinusCircle };

import IconMinusPath from './MinusPath';
export { IconMinusPath };

import IconMinusSquareFull from './MinusSquareFull';
export { IconMinusSquareFull };

import IconMinusSquare from './MinusSquare';
export { IconMinusSquare };

import IconMinus from './Minus';
export { IconMinus };

import IconMissedCall from './MissedCall';
export { IconMissedCall };

import IconMobileAndroidAlt from './MobileAndroidAlt';
export { IconMobileAndroidAlt };

import IconMobileAndroid from './MobileAndroid';
export { IconMobileAndroid };

import IconMobileVibrate from './MobileVibrate';
export { IconMobileVibrate };

import IconModem from './Modem';
export { IconModem };

import IconMoneyBillSlash from './MoneyBillSlash';
export { IconMoneyBillSlash };

import IconMoneyBillStack from './MoneyBillStack';
export { IconMoneyBillStack };

import IconMoneyBill from './MoneyBill';
export { IconMoneyBill };

import IconMoneyInsert from './MoneyInsert';
export { IconMoneyInsert };

import IconMoneyStack from './MoneyStack';
export { IconMoneyStack };

import IconMoneyWithdraw from './MoneyWithdraw';
export { IconMoneyWithdraw };

import IconMoneyWithdrawal from './MoneyWithdrawal';
export { IconMoneyWithdrawal };

import IconMoneybagAlt from './MoneybagAlt';
export { IconMoneybagAlt };

import IconMoneybag from './Moneybag';
export { IconMoneybag };

import IconMonitorHeartRate from './MonitorHeartRate';
export { IconMonitorHeartRate };

import IconMonitor from './Monitor';
export { IconMonitor };

import IconMoonEclipse from './MoonEclipse';
export { IconMoonEclipse };

import IconMoon from './Moon';
export { IconMoon };

import IconMoonset from './Moonset';
export { IconMoonset };

import IconMotor from './Motor';
export { IconMotor };

import IconMountainsSun from './MountainsSun';
export { IconMountainsSun };

import IconMountains from './Mountains';
export { IconMountains };

import IconMouseAlt2 from './MouseAlt2';
export { IconMouseAlt2 };

import IconMouseAlt from './MouseAlt';
export { IconMouseAlt };

import IconMouse from './Mouse';
export { IconMouse };

import IconMultiply from './Multiply';
export { IconMultiply };

import IconMusicNote from './MusicNote';
export { IconMusicNote };

import IconMusicTuneSlash from './MusicTuneSlash';
export { IconMusicTuneSlash };

import IconMusic from './Music';
export { IconMusic };

import IconNA from './NA';
export { IconNA };

import IconNavigator from './Navigator';
export { IconNavigator };

import IconNerd from './Nerd';
export { IconNerd };

import IconNewspaper from './Newspaper';
export { IconNewspaper };

import IconNinja from './Ninja';
export { IconNinja };

import IconNoEntry from './NoEntry';
export { IconNoEntry };

import IconNotebooks from './Notebooks';
export { IconNotebooks };

import IconNotes from './Notes';
export { IconNotes };

import IconObjectGroup from './ObjectGroup';
export { IconObjectGroup };

import IconObjectUngroup from './ObjectUngroup';
export { IconObjectUngroup };

import IconOctagon from './Octagon';
export { IconOctagon };

import IconOkta from './Okta';
export { IconOkta };

import IconOperaAlt from './OperaAlt';
export { IconOperaAlt };

import IconOpera from './Opera';
export { IconOpera };

import IconOutgoingCall from './OutgoingCall';
export { IconOutgoingCall };

import IconPackage from './Package';
export { IconPackage };

import IconPadlock from './Padlock';
export { IconPadlock };

import IconPagelines from './Pagelines';
export { IconPagelines };

import IconPagerduty from './Pagerduty';
export { IconPagerduty };

import IconPaintTool from './PaintTool';
export { IconPaintTool };

import IconPalette from './Palette';
export { IconPalette };

import IconPanelAdd from './PanelAdd';
export { IconPanelAdd };

import IconPanoramaHAlt from './PanoramaHAlt';
export { IconPanoramaHAlt };

import IconPanoramaH from './PanoramaH';
export { IconPanoramaH };

import IconPanoramaV from './PanoramaV';
export { IconPanoramaV };

import IconPaperclip from './Paperclip';
export { IconPaperclip };

import IconParagraph from './Paragraph';
export { IconParagraph };

import IconParcel from './Parcel';
export { IconParcel };

import IconParkingCircle from './ParkingCircle';
export { IconParkingCircle };

import IconParkingSquare from './ParkingSquare';
export { IconParkingSquare };

import IconPathfinderUnite from './PathfinderUnite';
export { IconPathfinderUnite };

import IconPathfinder from './Pathfinder';
export { IconPathfinder };

import IconPauseCircle from './PauseCircle';
export { IconPauseCircle };

import IconPause from './Pause';
export { IconPause };

import IconPaypal from './Paypal';
export { IconPaypal };

import IconPen from './Pen';
export { IconPen };

import IconPentagon from './Pentagon';
export { IconPentagon };

import IconPercentage from './Percentage';
export { IconPercentage };

import IconPhoneAlt from './PhoneAlt';
export { IconPhoneAlt };

import IconPhonePause from './PhonePause';
export { IconPhonePause };

import IconPhoneSlash from './PhoneSlash';
export { IconPhoneSlash };

import IconPhoneTimes from './PhoneTimes';
export { IconPhoneTimes };

import IconPhoneVolume from './PhoneVolume';
export { IconPhoneVolume };

import IconPhone from './Phone';
export { IconPhone };

import IconPicture from './Picture';
export { IconPicture };

import IconPizzaSlice from './PizzaSlice';
export { IconPizzaSlice };

import IconPlaneArrival from './PlaneArrival';
export { IconPlaneArrival };

import IconPlaneDeparture from './PlaneDeparture';
export { IconPlaneDeparture };

import IconPlaneFly from './PlaneFly';
export { IconPlaneFly };

import IconPlane from './Plane';
export { IconPlane };

import IconPlayCircle from './PlayCircle';
export { IconPlayCircle };

import IconPlay from './Play';
export { IconPlay };

import IconPlug from './Plug';
export { IconPlug };

import IconPlusCircle from './PlusCircle';
export { IconPlusCircle };

import IconPlusSquare from './PlusSquare';
export { IconPlusSquare };

import IconPlus from './Plus';
export { IconPlus };

import IconPodium from './Podium';
export { IconPodium };

import IconPolygon from './Polygon';
export { IconPolygon };

import IconPostStamp from './PostStamp';
export { IconPostStamp };

import IconPostcard from './Postcard';
export { IconPostcard };

import IconPoundCircle from './PoundCircle';
export { IconPoundCircle };

import IconPound from './Pound';
export { IconPound };

import IconPower from './Power';
export { IconPower };

import IconPrescriptionBottle from './PrescriptionBottle';
export { IconPrescriptionBottle };

import IconPresentationCheck from './PresentationCheck';
export { IconPresentationCheck };

import IconPresentationEdit from './PresentationEdit';
export { IconPresentationEdit };

import IconPresentationLine from './PresentationLine';
export { IconPresentationLine };

import IconPresentationLinesAlt from './PresentationLinesAlt';
export { IconPresentationLinesAlt };

import IconPresentationMinus from './PresentationMinus';
export { IconPresentationMinus };

import IconPresentationPlay from './PresentationPlay';
export { IconPresentationPlay };

import IconPresentationPlus from './PresentationPlus';
export { IconPresentationPlus };

import IconPresentationTimes from './PresentationTimes';
export { IconPresentationTimes };

import IconPresentation from './Presentation';
export { IconPresentation };

import IconPrevious from './Previous';
export { IconPrevious };

import IconPricetagAlt from './PricetagAlt';
export { IconPricetagAlt };

import IconPrintSlash from './PrintSlash';
export { IconPrintSlash };

import IconPrint from './Print';
export { IconPrint };

import IconProcess from './Process';
export { IconProcess };

import IconProcessor from './Processor';
export { IconProcessor };

import IconProgrammingLanguage from './ProgrammingLanguage';
export { IconProgrammingLanguage };

import IconPump from './Pump';
export { IconPump };

import IconPuzzlePiece from './PuzzlePiece';
export { IconPuzzlePiece };

import IconQrcodeScan from './QrcodeScan';
export { IconQrcodeScan };

import IconQuestionCircle from './QuestionCircle';
export { IconQuestionCircle };

import IconQuestion from './Question';
export { IconQuestion };

import IconRainbow from './Rainbow';
export { IconRainbow };

import IconRaindropsAlt from './RaindropsAlt';
export { IconRaindropsAlt };

import IconRaindrops from './Raindrops';
export { IconRaindrops };

import IconReact from './React';
export { IconReact };

import IconReceiptAlt from './ReceiptAlt';
export { IconReceiptAlt };

import IconReceipt from './Receipt';
export { IconReceipt };

import IconRecordAudio from './RecordAudio';
export { IconRecordAudio };

import IconRedditAlienAlt from './RedditAlienAlt';
export { IconRedditAlienAlt };

import IconRedo from './Redo';
export { IconRedo };

import IconRefresh from './Refresh';
export { IconRefresh };

import IconRegistered from './Registered';
export { IconRegistered };

import IconRepeat from './Repeat';
export { IconRepeat };

import IconRestaurant from './Restaurant';
export { IconRestaurant };

import IconRightIndentAlt from './RightIndentAlt';
export { IconRightIndentAlt };

import IconRightToLeftTextDirection from './RightToLeftTextDirection';
export { IconRightToLeftTextDirection };

import IconRobot from './Robot';
export { IconRobot };

import IconRocket from './Rocket';
export { IconRocket };

import IconRopeWay from './RopeWay';
export { IconRopeWay };

import IconRotate360 from './Rotate360';
export { IconRotate360 };

import IconRssAlt from './RssAlt';
export { IconRssAlt };

import IconRssInterface from './RssInterface';
export { IconRssInterface };

import IconRss from './Rss';
export { IconRss };

import IconRulerCombined from './RulerCombined';
export { IconRulerCombined };

import IconRuler from './Ruler';
export { IconRuler };

import IconRupeeSign from './RupeeSign';
export { IconRupeeSign };

import IconSadCry from './SadCry';
export { IconSadCry };

import IconSadCrying from './SadCrying';
export { IconSadCrying };

import IconSadDizzy from './SadDizzy';
export { IconSadDizzy };

import IconSadSquint from './SadSquint';
export { IconSadSquint };

import IconSad from './Sad';
export { IconSad };

import IconSanitizerAlt from './SanitizerAlt';
export { IconSanitizerAlt };

import IconSanitizer from './Sanitizer';
export { IconSanitizer };

import IconSave from './Save';
export { IconSave };

import IconScalingLeft from './ScalingLeft';
export { IconScalingLeft };

import IconScalingRight from './ScalingRight';
export { IconScalingRight };

import IconScenery from './Scenery';
export { IconScenery };

import IconSchedule from './Schedule';
export { IconSchedule };

import IconScrew from './Screw';
export { IconScrew };

import IconScrollH from './ScrollH';
export { IconScrollH };

import IconScroll from './Scroll';
export { IconScroll };

import IconSearchAlt from './SearchAlt';
export { IconSearchAlt };

import IconSearchMinus from './SearchMinus';
export { IconSearchMinus };

import IconSearchPlus from './SearchPlus';
export { IconSearchPlus };

import IconSearch from './Search';
export { IconSearch };

import IconSelfie from './Selfie';
export { IconSelfie };

import IconServerAlt from './ServerAlt';
export { IconServerAlt };

import IconServerConnection from './ServerConnection';
export { IconServerConnection };

import IconServerNetworkAlt from './ServerNetworkAlt';
export { IconServerNetworkAlt };

import IconServerNetwork from './ServerNetwork';
export { IconServerNetwork };

import IconServer from './Server';
export { IconServer };

import IconServers from './Servers';
export { IconServers };

import IconServicemark from './Servicemark';
export { IconServicemark };

import IconSetting from './Setting';
export { IconSetting };

import IconShareAlt from './ShareAlt';
export { IconShareAlt };

import IconShare from './Share';
export { IconShare };

import IconShieldCheck from './ShieldCheck';
export { IconShieldCheck };

import IconShieldExclamation from './ShieldExclamation';
export { IconShieldExclamation };

import IconShieldPlus from './ShieldPlus';
export { IconShieldPlus };

import IconShieldQuestion from './ShieldQuestion';
export { IconShieldQuestion };

import IconShieldSlash from './ShieldSlash';
export { IconShieldSlash };

import IconShield from './Shield';
export { IconShield };

import IconShip from './Ship';
export { IconShip };

import IconShop from './Shop';
export { IconShop };

import IconShoppingBag from './ShoppingBag';
export { IconShoppingBag };

import IconShoppingBasket from './ShoppingBasket';
export { IconShoppingBasket };

import IconShoppingCartAlt from './ShoppingCartAlt';
export { IconShoppingCartAlt };

import IconShoppingCart from './ShoppingCart';
export { IconShoppingCart };

import IconShovel from './Shovel';
export { IconShovel };

import IconShrink from './Shrink';
export { IconShrink };

import IconShuffle from './Shuffle';
export { IconShuffle };

import IconShutterAlt from './ShutterAlt';
export { IconShutterAlt };

import IconShutter from './Shutter';
export { IconShutter };

import IconSick from './Sick';
export { IconSick };

import IconSigma from './Sigma';
export { IconSigma };

import IconSignAlt from './SignAlt';
export { IconSignAlt };

import IconSignInAlt from './SignInAlt';
export { IconSignInAlt };

import IconSignLeft from './SignLeft';
export { IconSignLeft };

import IconSignOutAlt from './SignOutAlt';
export { IconSignOutAlt };

import IconSignRight from './SignRight';
export { IconSignRight };

import IconSignalAlt3 from './SignalAlt3';
export { IconSignalAlt3 };

import IconSignalAlt from './SignalAlt';
export { IconSignalAlt };

import IconSignal from './Signal';
export { IconSignal };

import IconSignin from './Signin';
export { IconSignin };

import IconSignout from './Signout';
export { IconSignout };

import IconSilence from './Silence';
export { IconSilence };

import IconSilentSquint from './SilentSquint';
export { IconSilentSquint };

import IconSimCard from './SimCard';
export { IconSimCard };

import IconSitemap from './Sitemap';
export { IconSitemap };

import IconSkipForwardAlt from './SkipForwardAlt';
export { IconSkipForwardAlt };

import IconSkipForwardCircle from './SkipForwardCircle';
export { IconSkipForwardCircle };

import IconSkipForward from './SkipForward';
export { IconSkipForward };

import IconSkypeAlt from './SkypeAlt';
export { IconSkypeAlt };

import IconSkype from './Skype';
export { IconSkype };

import IconSlackAlt from './SlackAlt';
export { IconSlackAlt };

import IconSlack from './Slack';
export { IconSlack };

import IconSliderHRange from './SliderHRange';
export { IconSliderHRange };

import IconSliderH from './SliderH';
export { IconSliderH };

import IconSlidersVAlt from './SlidersVAlt';
export { IconSlidersVAlt };

import IconSlidersV from './SlidersV';
export { IconSlidersV };

import IconSmileBeam from './SmileBeam';
export { IconSmileBeam };

import IconSmileDizzy from './SmileDizzy';
export { IconSmileDizzy };

import IconSmileSquintWinkAlt from './SmileSquintWinkAlt';
export { IconSmileSquintWinkAlt };

import IconSmileSquintWink from './SmileSquintWink';
export { IconSmileSquintWink };

import IconSmileWinkAlt from './SmileWinkAlt';
export { IconSmileWinkAlt };

import IconSmileWink from './SmileWink';
export { IconSmileWink };

import IconSmile from './Smile';
export { IconSmile };

import IconSnapchatAlt from './SnapchatAlt';
export { IconSnapchatAlt };

import IconSnapchatGhost from './SnapchatGhost';
export { IconSnapchatGhost };

import IconSnapchatSquare from './SnapchatSquare';
export { IconSnapchatSquare };

import IconSnowFlake from './SnowFlake';
export { IconSnowFlake };

import IconSnowflakeAlt from './SnowflakeAlt';
export { IconSnowflakeAlt };

import IconSocialDistancing from './SocialDistancing';
export { IconSocialDistancing };

import IconSortAmountDown from './SortAmountDown';
export { IconSortAmountDown };

import IconSortAmountUp from './SortAmountUp';
export { IconSortAmountUp };

import IconSort from './Sort';
export { IconSort };

import IconSorting from './Sorting';
export { IconSorting };

import IconSpaceKey from './SpaceKey';
export { IconSpaceKey };

import IconSpade from './Spade';
export { IconSpade };

import IconSperms from './Sperms';
export { IconSperms };

import IconSpin from './Spin';
export { IconSpin };

import IconSpinnerAlt from './SpinnerAlt';
export { IconSpinnerAlt };

import IconSpinner from './Spinner';
export { IconSpinner };

import IconSquareFull from './SquareFull';
export { IconSquareFull };

import IconSquareShape from './SquareShape';
export { IconSquareShape };

import IconSquare from './Square';
export { IconSquare };

import IconSquint from './Squint';
export { IconSquint };

import IconStarHalfAlt from './StarHalfAlt';
export { IconStarHalfAlt };

import IconStar from './Star';
export { IconStar };

import IconStepBackwardAlt from './StepBackwardAlt';
export { IconStepBackwardAlt };

import IconStepBackwardCircle from './StepBackwardCircle';
export { IconStepBackwardCircle };

import IconStepBackward from './StepBackward';
export { IconStepBackward };

import IconStepForward from './StepForward';
export { IconStepForward };

import IconStethoscopeAlt from './StethoscopeAlt';
export { IconStethoscopeAlt };

import IconStethoscope from './Stethoscope';
export { IconStethoscope };

import IconStopCircle from './StopCircle';
export { IconStopCircle };

import IconStopwatchSlash from './StopwatchSlash';
export { IconStopwatchSlash };

import IconStopwatch from './Stopwatch';
export { IconStopwatch };

import IconStoreAlt from './StoreAlt';
export { IconStoreAlt };

import IconStoreSlash from './StoreSlash';
export { IconStoreSlash };

import IconStore from './Store';
export { IconStore };

import IconStreering from './Streering';
export { IconStreering };

import IconStretcher from './Stretcher';
export { IconStretcher };

import IconSubject from './Subject';
export { IconSubject };

import IconSubwayAlt from './SubwayAlt';
export { IconSubwayAlt };

import IconSubway from './Subway';
export { IconSubway };

import IconSuitcaseAlt from './SuitcaseAlt';
export { IconSuitcaseAlt };

import IconSuitcase from './Suitcase';
export { IconSuitcase };

import IconSun from './Sun';
export { IconSun };

import IconSunset from './Sunset';
export { IconSunset };

import IconSurprise from './Surprise';
export { IconSurprise };

import IconSwatchbook from './Swatchbook';
export { IconSwatchbook };

import IconSwiggy from './Swiggy';
export { IconSwiggy };

import IconSwimmer from './Swimmer';
export { IconSwimmer };

import IconSyncExclamation from './SyncExclamation';
export { IconSyncExclamation };

import IconSyncSlash from './SyncSlash';
export { IconSyncSlash };

import IconSync from './Sync';
export { IconSync };

import IconSyringe from './Syringe';
export { IconSyringe };

import IconTableTennis from './TableTennis';
export { IconTableTennis };

import IconTable from './Table';
export { IconTable };

import IconTablet from './Tablet';
export { IconTablet };

import IconTablets from './Tablets';
export { IconTablets };

import IconTachometerFastAlt from './TachometerFastAlt';
export { IconTachometerFastAlt };

import IconTachometerFast from './TachometerFast';
export { IconTachometerFast };

import IconTagAlt from './TagAlt';
export { IconTagAlt };

import IconTag from './Tag';
export { IconTag };

import IconTape from './Tape';
export { IconTape };

import IconTaxi from './Taxi';
export { IconTaxi };

import IconTear from './Tear';
export { IconTear };

import IconTelegramAlt from './TelegramAlt';
export { IconTelegramAlt };

import IconTelegram from './Telegram';
export { IconTelegram };

import IconTelescope from './Telescope';
export { IconTelescope };

import IconTemperatureEmpty from './TemperatureEmpty';
export { IconTemperatureEmpty };

import IconTemperatureHalf from './TemperatureHalf';
export { IconTemperatureHalf };

import IconTemperatureMinus from './TemperatureMinus';
export { IconTemperatureMinus };

import IconTemperaturePlus from './TemperaturePlus';
export { IconTemperaturePlus };

import IconTemperatureQuarter from './TemperatureQuarter';
export { IconTemperatureQuarter };

import IconTemperatureThreeQuarter from './TemperatureThreeQuarter';
export { IconTemperatureThreeQuarter };

import IconTemperature from './Temperature';
export { IconTemperature };

import IconTennisBall from './TennisBall';
export { IconTennisBall };

import IconTextFields from './TextFields';
export { IconTextFields };

import IconTextSize from './TextSize';
export { IconTextSize };

import IconTextStrikeThrough from './TextStrikeThrough';
export { IconTextStrikeThrough };

import IconText from './Text';
export { IconText };

import IconThLarge from './ThLarge';
export { IconThLarge };

import IconThSlash from './ThSlash';
export { IconThSlash };

import IconTh from './Th';
export { IconTh };

import IconThermometer from './Thermometer';
export { IconThermometer };

import IconThumbsDown from './ThumbsDown';
export { IconThumbsDown };

import IconThumbsUp from './ThumbsUp';
export { IconThumbsUp };

import IconThunderstormMoon from './ThunderstormMoon';
export { IconThunderstormMoon };

import IconThunderstormSun from './ThunderstormSun';
export { IconThunderstormSun };

import IconThunderstorm from './Thunderstorm';
export { IconThunderstorm };

import IconTicket from './Ticket';
export { IconTicket };

import IconTimesCircle from './TimesCircle';
export { IconTimesCircle };

import IconTimesSquare from './TimesSquare';
export { IconTimesSquare };

import IconTimes from './Times';
export { IconTimes };

import IconToggleOff from './ToggleOff';
export { IconToggleOff };

import IconToggleOn from './ToggleOn';
export { IconToggleOn };

import IconToiletPaper from './ToiletPaper';
export { IconToiletPaper };

import IconTopArrowFromTop from './TopArrowFromTop';
export { IconTopArrowFromTop };

import IconTopArrowToTop from './TopArrowToTop';
export { IconTopArrowToTop };

import IconTornado from './Tornado';
export { IconTornado };

import IconTrademarkCircle from './TrademarkCircle';
export { IconTrademarkCircle };

import IconTrademark from './Trademark';
export { IconTrademark };

import IconTrafficBarrier from './TrafficBarrier';
export { IconTrafficBarrier };

import IconTrafficLight from './TrafficLight';
export { IconTrafficLight };

import IconTransaction from './Transaction';
export { IconTransaction };

import IconTrashAlt from './TrashAlt';
export { IconTrashAlt };

import IconTrash from './Trash';
export { IconTrash };

import IconTrees from './Trees';
export { IconTrees };

import IconTriangle from './Triangle';
export { IconTriangle };

import IconTrophy from './Trophy';
export { IconTrophy };

import IconTrowel from './Trowel';
export { IconTrowel };

import IconTruckLoading from './TruckLoading';
export { IconTruckLoading };

import IconTruck from './Truck';
export { IconTruck };

import IconTumblrAlt from './TumblrAlt';
export { IconTumblrAlt };

import IconTumblrSquare from './TumblrSquare';
export { IconTumblrSquare };

import IconTumblr from './Tumblr';
export { IconTumblr };

import IconTvRetroSlash from './TvRetroSlash';
export { IconTvRetroSlash };

import IconTvRetro from './TvRetro';
export { IconTvRetro };

import IconTwitterAlt from './TwitterAlt';
export { IconTwitterAlt };

import IconTwitter from './Twitter';
export { IconTwitter };

import IconUmbrella from './Umbrella';
export { IconUmbrella };

import IconUnamused from './Unamused';
export { IconUnamused };

import IconUnderline from './Underline';
export { IconUnderline };

import IconUniversity from './University';
export { IconUniversity };

import IconUnlockAlt from './UnlockAlt';
export { IconUnlockAlt };

import IconUnlock from './Unlock';
export { IconUnlock };

import IconUploadAlt from './UploadAlt';
export { IconUploadAlt };

import IconUpload from './Upload';
export { IconUpload };

import IconUsdCircle from './UsdCircle';
export { IconUsdCircle };

import IconUsdSquare from './UsdSquare';
export { IconUsdSquare };

import IconUserArrows from './UserArrows';
export { IconUserArrows };

import IconUserCheck from './UserCheck';
export { IconUserCheck };

import IconUserCircle from './UserCircle';
export { IconUserCircle };

import IconUserExclamation from './UserExclamation';
export { IconUserExclamation };

import IconUserLocation from './UserLocation';
export { IconUserLocation };

import IconUserMd from './UserMd';
export { IconUserMd };

import IconUserMinus from './UserMinus';
export { IconUserMinus };

import IconUserNurse from './UserNurse';
export { IconUserNurse };

import IconUserPlus from './UserPlus';
export { IconUserPlus };

import IconUserSquare from './UserSquare';
export { IconUserSquare };

import IconUserTimes from './UserTimes';
export { IconUserTimes };

import IconUser from './User';
export { IconUser };

import IconUsersAlt from './UsersAlt';
export { IconUsersAlt };

import IconUtensilsAlt from './UtensilsAlt';
export { IconUtensilsAlt };

import IconUtensils from './Utensils';
export { IconUtensils };

import IconVectorSquareAlt from './VectorSquareAlt';
export { IconVectorSquareAlt };

import IconVectorSquare from './VectorSquare';
export { IconVectorSquare };

import IconVenus from './Venus';
export { IconVenus };

import IconVerticalAlignBottom from './VerticalAlignBottom';
export { IconVerticalAlignBottom };

import IconVerticalAlignCenter from './VerticalAlignCenter';
export { IconVerticalAlignCenter };

import IconVerticalAlignTop from './VerticalAlignTop';
export { IconVerticalAlignTop };

import IconVerticalDistributeBottom from './VerticalDistributeBottom';
export { IconVerticalDistributeBottom };

import IconVerticalDistributionCenter from './VerticalDistributionCenter';
export { IconVerticalDistributionCenter };

import IconVerticalDistributionTop from './VerticalDistributionTop';
export { IconVerticalDistributionTop };

import IconVideoQuestion from './VideoQuestion';
export { IconVideoQuestion };

import IconVideoSlash from './VideoSlash';
export { IconVideoSlash };

import IconVideo from './Video';
export { IconVideo };

import IconVirusSlash from './VirusSlash';
export { IconVirusSlash };

import IconVisualStudio from './VisualStudio';
export { IconVisualStudio };

import IconVkAlt from './VkAlt';
export { IconVkAlt };

import IconVk from './Vk';
export { IconVk };

import IconVoicemailRectangle from './VoicemailRectangle';
export { IconVoicemailRectangle };

import IconVoicemail from './Voicemail';
export { IconVoicemail };

import IconVolleyball from './Volleyball';
export { IconVolleyball };

import IconVolumeDown from './VolumeDown';
export { IconVolumeDown };

import IconVolumeMute from './VolumeMute';
export { IconVolumeMute };

import IconVolumeOff from './VolumeOff';
export { IconVolumeOff };

import IconVolumeUp from './VolumeUp';
export { IconVolumeUp };

import IconVolume from './Volume';
export { IconVolume };

import IconVuejsAlt from './VuejsAlt';
export { IconVuejsAlt };

import IconVuejs from './Vuejs';
export { IconVuejs };

import IconWall from './Wall';
export { IconWall };

import IconWallet from './Wallet';
export { IconWallet };

import IconWatchAlt from './WatchAlt';
export { IconWatchAlt };

import IconWatch from './Watch';
export { IconWatch };

import IconWaterDropSlash from './WaterDropSlash';
export { IconWaterDropSlash };

import IconWaterGlass from './WaterGlass';
export { IconWaterGlass };

import IconWater from './Water';
export { IconWater };

import IconWebGridAlt from './WebGridAlt';
export { IconWebGridAlt };

import IconWebGrid from './WebGrid';
export { IconWebGrid };

import IconWebSectionAlt from './WebSectionAlt';
export { IconWebSectionAlt };

import IconWebSection from './WebSection';
export { IconWebSection };

import IconWebcam from './Webcam';
export { IconWebcam };

import IconWeight from './Weight';
export { IconWeight };

import IconWhatsappAlt from './WhatsappAlt';
export { IconWhatsappAlt };

import IconWhatsapp from './Whatsapp';
export { IconWhatsapp };

import IconWheelBarrow from './WheelBarrow';
export { IconWheelBarrow };

import IconWheelchairAlt from './WheelchairAlt';
export { IconWheelchairAlt };

import IconWheelchair from './Wheelchair';
export { IconWheelchair };

import IconWifiRouter from './WifiRouter';
export { IconWifiRouter };

import IconWifiSlash from './WifiSlash';
export { IconWifiSlash };

import IconWifi from './Wifi';
export { IconWifi };

import IconWindMoon from './WindMoon';
export { IconWindMoon };

import IconWindSun from './WindSun';
export { IconWindSun };

import IconWind from './Wind';
export { IconWind };

import IconWindowGrid from './WindowGrid';
export { IconWindowGrid };

import IconWindowMaximize from './WindowMaximize';
export { IconWindowMaximize };

import IconWindowSection from './WindowSection';
export { IconWindowSection };

import IconWindow from './Window';
export { IconWindow };

import IconWindows from './Windows';
export { IconWindows };

import IconWindsock from './Windsock';
export { IconWindsock };

import IconWindy from './Windy';
export { IconWindy };

import IconWordpressSimple from './WordpressSimple';
export { IconWordpressSimple };

import IconWordpress from './Wordpress';
export { IconWordpress };

import IconWrapText from './WrapText';
export { IconWrapText };

import IconWrench from './Wrench';
export { IconWrench };

import IconXAdd from './XAdd';
export { IconXAdd };

import IconX from './X';
export { IconX };

import IconYenCircle from './YenCircle';
export { IconYenCircle };

import IconYen from './Yen';
export { IconYen };

import IconYinYang from './YinYang';
export { IconYinYang };

import IconYoutube from './Youtube';
export { IconYoutube };

export function mapper(icon: string) {
  switch (icon) {
    case '0-plus':
      return <Icon0Plus />;
    case '10-plus':
      return <Icon10Plus />;
    case '12-plus':
      return <Icon12Plus />;
    case '13-plus':
      return <Icon13Plus />;
    case '16-plus':
      return <Icon16Plus />;
    case '17-plus':
      return <Icon17Plus />;
    case '18-plus':
      return <Icon18Plus />;
    case '21-plus':
      return <Icon21Plus />;
    case '3-plus':
      return <Icon3Plus />;
    case '500px':
      return <Icon500Px />;
    case '6-plus':
      return <Icon6Plus />;
    case 'abacus':
      return <IconAbacus />;
    case 'accessible-icon-alt':
      return <IconAccessibleIconAlt />;
    case 'adjust-alt':
      return <IconAdjustAlt />;
    case 'adjust-circle':
      return <IconAdjustCircle />;
    case 'adjust-half':
      return <IconAdjustHalf />;
    case 'adjust':
      return <IconAdjust />;
    case 'adobe-alt':
      return <IconAdobeAlt />;
    case 'adobe':
      return <IconAdobe />;
    case 'airplay':
      return <IconAirplay />;
    case 'align-alt':
      return <IconAlignAlt />;
    case 'align-center-alt':
      return <IconAlignCenterAlt />;
    case 'align-center-h':
      return <IconAlignCenterH />;
    case 'align-center-justify':
      return <IconAlignCenterJustify />;
    case 'align-center-v':
      return <IconAlignCenterV />;
    case 'align-center':
      return <IconAlignCenter />;
    case 'align-justify':
      return <IconAlignJustify />;
    case 'align-left-justify':
      return <IconAlignLeftJustify />;
    case 'align-left':
      return <IconAlignLeft />;
    case 'align-letter-right':
      return <IconAlignLetterRight />;
    case 'align-right-justify':
      return <IconAlignRightJustify />;
    case 'align-right':
      return <IconAlignRight />;
    case 'align':
      return <IconAlign />;
    case 'amazon':
      return <IconAmazon />;
    case 'ambulance':
      return <IconAmbulance />;
    case 'analysis':
      return <IconAnalysis />;
    case 'analytics':
      return <IconAnalytics />;
    case 'anchor':
      return <IconAnchor />;
    case 'android-alt':
      return <IconAndroidAlt />;
    case 'android-phone-slash':
      return <IconAndroidPhoneSlash />;
    case 'android':
      return <IconAndroid />;
    case 'angle-double-down':
      return <IconAngleDoubleDown />;
    case 'angle-double-left':
      return <IconAngleDoubleLeft />;
    case 'angle-double-right':
      return <IconAngleDoubleRight />;
    case 'angle-double-up':
      return <IconAngleDoubleUp />;
    case 'angle-down':
      return <IconAngleDown />;
    case 'angle-left-b':
      return <IconAngleLeftB />;
    case 'angle-left':
      return <IconAngleLeft />;
    case 'angle-right-b':
      return <IconAngleRightB />;
    case 'angle-right':
      return <IconAngleRight />;
    case 'angle-up':
      return <IconAngleUp />;
    case 'angry':
      return <IconAngry />;
    case 'ankh':
      return <IconAnkh />;
    case 'annoyed-alt':
      return <IconAnnoyedAlt />;
    case 'annoyed':
      return <IconAnnoyed />;
    case 'apple-alt':
      return <IconAppleAlt />;
    case 'apple':
      return <IconApple />;
    case 'apps':
      return <IconApps />;
    case 'archive-alt':
      return <IconArchiveAlt />;
    case 'archive':
      return <IconArchive />;
    case 'archway':
      return <IconArchway />;
    case 'arrow-break':
      return <IconArrowBreak />;
    case 'arrow-circle-down':
      return <IconArrowCircleDown />;
    case 'arrow-circle-left':
      return <IconArrowCircleLeft />;
    case 'arrow-circle-right':
      return <IconArrowCircleRight />;
    case 'arrow-circle-up':
      return <IconArrowCircleUp />;
    case 'arrow-compress-h':
      return <IconArrowCompressH />;
    case 'arrow-down-left':
      return <IconArrowDownLeft />;
    case 'arrow-down-right':
      return <IconArrowDownRight />;
    case 'arrow-down':
      return <IconArrowDown />;
    case 'arrow-from-right':
      return <IconArrowFromRight />;
    case 'arrow-from-top':
      return <IconArrowFromTop />;
    case 'arrow-growth':
      return <IconArrowGrowth />;
    case 'arrow-left':
      return <IconArrowLeft />;
    case 'arrow-random':
      return <IconArrowRandom />;
    case 'arrow-resize-diagonal':
      return <IconArrowResizeDiagonal />;
    case 'arrow-right':
      return <IconArrowRight />;
    case 'arrow-to-bottom':
      return <IconArrowToBottom />;
    case 'arrow-to-right':
      return <IconArrowToRight />;
    case 'arrow-up-left':
      return <IconArrowUpLeft />;
    case 'arrow-up-right':
      return <IconArrowUpRight />;
    case 'arrow-up':
      return <IconArrowUp />;
    case 'arrow':
      return <IconArrow />;
    case 'arrows-h-alt':
      return <IconArrowsHAlt />;
    case 'arrows-h':
      return <IconArrowsH />;
    case 'arrows-left-down':
      return <IconArrowsLeftDown />;
    case 'arrows-maximize':
      return <IconArrowsMaximize />;
    case 'arrows-merge':
      return <IconArrowsMerge />;
    case 'arrows-resize-h':
      return <IconArrowsResizeH />;
    case 'arrows-resize-v':
      return <IconArrowsResizeV />;
    case 'arrows-resize':
      return <IconArrowsResize />;
    case 'arrows-right-down':
      return <IconArrowsRightDown />;
    case 'arrows-shrink-h':
      return <IconArrowsShrinkH />;
    case 'arrows-shrink-v':
      return <IconArrowsShrinkV />;
    case 'arrows-up-right':
      return <IconArrowsUpRight />;
    case 'arrows-v-alt':
      return <IconArrowsVAlt />;
    case 'arrows-v':
      return <IconArrowsV />;
    case 'assistive-listening-systems':
      return <IconAssistiveListeningSystems />;
    case 'asterisk':
      return <IconAsterisk />;
    case 'at':
      return <IconAt />;
    case 'atom':
      return <IconAtom />;
    case 'auto-flash':
      return <IconAutoFlash />;
    case 'award-alt':
      return <IconAwardAlt />;
    case 'award':
      return <IconAward />;
    case 'baby-carriage':
      return <IconBabyCarriage />;
    case 'backpack':
      return <IconBackpack />;
    case 'backspace':
      return <IconBackspace />;
    case 'backward':
      return <IconBackward />;
    case 'bag-alt':
      return <IconBagAlt />;
    case 'bag-slash':
      return <IconBagSlash />;
    case 'bag':
      return <IconBag />;
    case 'balance-scale':
      return <IconBalanceScale />;
    case 'ban':
      return <IconBan />;
    case 'band-aid':
      return <IconBandAid />;
    case 'bars':
      return <IconBars />;
    case 'baseball-ball':
      return <IconBaseballBall />;
    case 'basketball-hoop':
      return <IconBasketballHoop />;
    case 'basketball':
      return <IconBasketball />;
    case 'bath':
      return <IconBath />;
    case 'battery-bolt':
      return <IconBatteryBolt />;
    case 'battery-empty':
      return <IconBatteryEmpty />;
    case 'bed-double':
      return <IconBedDouble />;
    case 'bed':
      return <IconBed />;
    case 'behance-alt':
      return <IconBehanceAlt />;
    case 'behance':
      return <IconBehance />;
    case 'bell-school':
      return <IconBellSchool />;
    case 'bell-slash':
      return <IconBellSlash />;
    case 'bell':
      return <IconBell />;
    case 'bill':
      return <IconBill />;
    case 'bing':
      return <IconBing />;
    case 'bitcoin-alt':
      return <IconBitcoinAlt />;
    case 'bitcoin-circle':
      return <IconBitcoinCircle />;
    case 'bitcoin-sign':
      return <IconBitcoinSign />;
    case 'bitcoin':
      return <IconBitcoin />;
    case 'black-berry':
      return <IconBlackBerry />;
    case 'blogger-alt':
      return <IconBloggerAlt />;
    case 'blogger':
      return <IconBlogger />;
    case 'bluetooth-b':
      return <IconBluetoothB />;
    case 'bold':
      return <IconBold />;
    case 'bolt-alt':
      return <IconBoltAlt />;
    case 'bolt-slash':
      return <IconBoltSlash />;
    case 'bolt':
      return <IconBolt />;
    case 'book-alt':
      return <IconBookAlt />;
    case 'book-medical':
      return <IconBookMedical />;
    case 'book-open':
      return <IconBookOpen />;
    case 'book-reader':
      return <IconBookReader />;
    case 'book':
      return <IconBook />;
    case 'bookmark-full':
      return <IconBookmarkFull />;
    case 'bookmark':
      return <IconBookmark />;
    case 'books':
      return <IconBooks />;
    case 'boombox':
      return <IconBoombox />;
    case 'border-alt':
      return <IconBorderAlt />;
    case 'border-bottom':
      return <IconBorderBottom />;
    case 'border-clear':
      return <IconBorderClear />;
    case 'border-horizontal':
      return <IconBorderHorizontal />;
    case 'border-inner':
      return <IconBorderInner />;
    case 'border-left':
      return <IconBorderLeft />;
    case 'border-out':
      return <IconBorderOut />;
    case 'border-right':
      return <IconBorderRight />;
    case 'border-top':
      return <IconBorderTop />;
    case 'border-vertical':
      return <IconBorderVertical />;
    case 'bowling-ball':
      return <IconBowlingBall />;
    case 'box':
      return <IconBox />;
    case 'brackets-curly':
      return <IconBracketsCurly />;
    case 'brain':
      return <IconBrain />;
    case 'briefcase-alt':
      return <IconBriefcaseAlt />;
    case 'briefcase':
      return <IconBriefcase />;
    case 'bright':
      return <IconBright />;
    case 'brightness-empty':
      return <IconBrightnessEmpty />;
    case 'brightness-half':
      return <IconBrightnessHalf />;
    case 'brightness-low':
      return <IconBrightnessLow />;
    case 'brightness-minus':
      return <IconBrightnessMinus />;
    case 'brightness-plus':
      return <IconBrightnessPlus />;
    case 'brightness':
      return <IconBrightness />;
    case 'bring-bottom':
      return <IconBringBottom />;
    case 'bring-front':
      return <IconBringFront />;
    case 'browser':
      return <IconBrowser />;
    case 'brush-alt':
      return <IconBrushAlt />;
    case 'bug':
      return <IconBug />;
    case 'building':
      return <IconBuilding />;
    case 'bullseye':
      return <IconBullseye />;
    case 'bus-alt':
      return <IconBusAlt />;
    case 'bus-school':
      return <IconBusSchool />;
    case 'bus':
      return <IconBus />;
    case 'calculator-alt':
      return <IconCalculatorAlt />;
    case 'calculator':
      return <IconCalculator />;
    case 'calendar-alt':
      return <IconCalendarAlt />;
    case 'calendar-slash':
      return <IconCalendarSlash />;
    case 'calender':
      return <IconCalender />;
    case 'calling':
      return <IconCalling />;
    case 'camera-change':
      return <IconCameraChange />;
    case 'camera-plus':
      return <IconCameraPlus />;
    case 'camera-slash':
      return <IconCameraSlash />;
    case 'camera':
      return <IconCamera />;
    case 'cancel':
      return <IconCancel />;
    case 'capsule':
      return <IconCapsule />;
    case 'capture':
      return <IconCapture />;
    case 'car-sideview':
      return <IconCarSideview />;
    case 'car-slash':
      return <IconCarSlash />;
    case 'car-wash':
      return <IconCarWash />;
    case 'car':
      return <IconCar />;
    case 'card-atm':
      return <IconCardAtm />;
    case 'caret-right':
      return <IconCaretRight />;
    case 'cell':
      return <IconCell />;
    case 'celsius':
      return <IconCelsius />;
    case 'channel-add':
      return <IconChannelAdd />;
    case 'channel':
      return <IconChannel />;
    case 'chart-bar-alt':
      return <IconChartBarAlt />;
    case 'chart-bar':
      return <IconChartBar />;
    case 'chart-down':
      return <IconChartDown />;
    case 'chart-growth-alt':
      return <IconChartGrowthAlt />;
    case 'chart-growth':
      return <IconChartGrowth />;
    case 'chart-line':
      return <IconChartLine />;
    case 'chart-pie-alt':
      return <IconChartPieAlt />;
    case 'chart-pie':
      return <IconChartPie />;
    case 'chart':
      return <IconChart />;
    case 'chat-bubble-user':
      return <IconChatBubbleUser />;
    case 'chat-info':
      return <IconChatInfo />;
    case 'chat':
      return <IconChat />;
    case 'check-circle':
      return <IconCheckCircle />;
    case 'check-square':
      return <IconCheckSquare />;
    case 'check':
      return <IconCheck />;
    case 'circle-layer':
      return <IconCircleLayer />;
    case 'circle':
      return <IconCircle />;
    case 'circuit':
      return <IconCircuit />;
    case 'clapper-board':
      return <IconClapperBoard />;
    case 'clinic-medical':
      return <IconClinicMedical />;
    case 'clipboard-alt':
      return <IconClipboardAlt />;
    case 'clipboard-blank':
      return <IconClipboardBlank />;
    case 'clipboard-notes':
      return <IconClipboardNotes />;
    case 'clipboard':
      return <IconClipboard />;
    case 'clock-eight':
      return <IconClockEight />;
    case 'clock-five':
      return <IconClockFive />;
    case 'clock-nine':
      return <IconClockNine />;
    case 'clock-seven':
      return <IconClockSeven />;
    case 'clock-ten':
      return <IconClockTen />;
    case 'clock-three':
      return <IconClockThree />;
    case 'clock-two':
      return <IconClockTwo />;
    case 'clock':
      return <IconClock />;
    case 'closed-captioning-slash':
      return <IconClosedCaptioningSlash />;
    case 'closed-captioning':
      return <IconClosedCaptioning />;
    case 'cloud-block':
      return <IconCloudBlock />;
    case 'cloud-bookmark':
      return <IconCloudBookmark />;
    case 'cloud-check':
      return <IconCloudCheck />;
    case 'cloud-computing':
      return <IconCloudComputing />;
    case 'cloud-data-connection':
      return <IconCloudDataConnection />;
    case 'cloud-database-tree':
      return <IconCloudDatabaseTree />;
    case 'cloud-download':
      return <IconCloudDownload />;
    case 'cloud-drizzle':
      return <IconCloudDrizzle />;
    case 'cloud-exclamation':
      return <IconCloudExclamation />;
    case 'cloud-hail':
      return <IconCloudHail />;
    case 'cloud-heart':
      return <IconCloudHeart />;
    case 'cloud-info':
      return <IconCloudInfo />;
    case 'cloud-lock':
      return <IconCloudLock />;
    case 'cloud-meatball':
      return <IconCloudMeatball />;
    case 'cloud-moon-hail':
      return <IconCloudMoonHail />;
    case 'cloud-moon-meatball':
      return <IconCloudMoonMeatball />;
    case 'cloud-moon-rain':
      return <IconCloudMoonRain />;
    case 'cloud-moon-showers':
      return <IconCloudMoonShowers />;
    case 'cloud-moon':
      return <IconCloudMoon />;
    case 'cloud-question':
      return <IconCloudQuestion />;
    case 'cloud-rain-sun':
      return <IconCloudRainSun />;
    case 'cloud-rain':
      return <IconCloudRain />;
    case 'cloud-redo':
      return <IconCloudRedo />;
    case 'cloud-share':
      return <IconCloudShare />;
    case 'cloud-shield':
      return <IconCloudShield />;
    case 'cloud-showers-alt':
      return <IconCloudShowersAlt />;
    case 'cloud-showers-heavy':
      return <IconCloudShowersHeavy />;
    case 'cloud-showers':
      return <IconCloudShowers />;
    case 'cloud-slash':
      return <IconCloudSlash />;
    case 'cloud-sun-hail':
      return <IconCloudSunHail />;
    case 'cloud-sun-meatball':
      return <IconCloudSunMeatball />;
    case 'cloud-sun-rain-alt':
      return <IconCloudSunRainAlt />;
    case 'cloud-sun-rain':
      return <IconCloudSunRain />;
    case 'cloud-sun-tear':
      return <IconCloudSunTear />;
    case 'cloud-sun':
      return <IconCloudSun />;
    case 'cloud-times':
      return <IconCloudTimes />;
    case 'cloud-unlock':
      return <IconCloudUnlock />;
    case 'cloud-upload':
      return <IconCloudUpload />;
    case 'cloud-wifi':
      return <IconCloudWifi />;
    case 'cloud-wind':
      return <IconCloudWind />;
    case 'cloud':
      return <IconCloud />;
    case 'clouds':
      return <IconClouds />;
    case 'club':
      return <IconClub />;
    case 'code-branch':
      return <IconCodeBranch />;
    case 'coffee':
      return <IconCoffee />;
    case 'cog':
      return <IconCog />;
    case 'coins':
      return <IconCoins />;
    case 'columns':
      return <IconColumns />;
    case 'comment-add':
      return <IconCommentAdd />;
    case 'comment-alt-block':
      return <IconCommentAltBlock />;
    case 'comment-alt-chart-lines':
      return <IconCommentAltChartLines />;
    case 'comment-alt-check':
      return <IconCommentAltCheck />;
    case 'comment-alt-dots':
      return <IconCommentAltDots />;
    case 'comment-alt-download':
      return <IconCommentAltDownload />;
    case 'comment-alt-edit':
      return <IconCommentAltEdit />;
    case 'comment-alt-exclamation':
      return <IconCommentAltExclamation />;
    case 'comment-alt-heart':
      return <IconCommentAltHeart />;
    case 'comment-alt-image':
      return <IconCommentAltImage />;
    case 'comment-alt-info':
      return <IconCommentAltInfo />;
    case 'comment-alt-lines':
      return <IconCommentAltLines />;
    case 'comment-alt-lock':
      return <IconCommentAltLock />;
    case 'comment-alt-medical':
      return <IconCommentAltMedical />;
    case 'comment-alt-message':
      return <IconCommentAltMessage />;
    case 'comment-alt-notes':
      return <IconCommentAltNotes />;
    case 'comment-alt-plus':
      return <IconCommentAltPlus />;
    case 'comment-alt-question':
      return <IconCommentAltQuestion />;
    case 'comment-alt-redo':
      return <IconCommentAltRedo />;
    case 'comment-alt-search':
      return <IconCommentAltSearch />;
    case 'comment-alt-share':
      return <IconCommentAltShare />;
    case 'comment-alt-shield':
      return <IconCommentAltShield />;
    case 'comment-alt-slash':
      return <IconCommentAltSlash />;
    case 'comment-alt-upload':
      return <IconCommentAltUpload />;
    case 'comment-alt-verify':
      return <IconCommentAltVerify />;
    case 'comment-alt':
      return <IconCommentAlt />;
    case 'comment-block':
      return <IconCommentBlock />;
    case 'comment-chart-line':
      return <IconCommentChartLine />;
    case 'comment-check':
      return <IconCommentCheck />;
    case 'comment-dots':
      return <IconCommentDots />;
    case 'comment-download':
      return <IconCommentDownload />;
    case 'comment-edit':
      return <IconCommentEdit />;
    case 'comment-exclamation':
      return <IconCommentExclamation />;
    case 'comment-heart':
      return <IconCommentHeart />;
    case 'comment-image':
      return <IconCommentImage />;
    case 'comment-info-alt':
      return <IconCommentInfoAlt />;
    case 'comment-info':
      return <IconCommentInfo />;
    case 'comment-lines':
      return <IconCommentLines />;
    case 'comment-lock':
      return <IconCommentLock />;
    case 'comment-medical':
      return <IconCommentMedical />;
    case 'comment-message':
      return <IconCommentMessage />;
    case 'comment-notes':
      return <IconCommentNotes />;
    case 'comment-plus':
      return <IconCommentPlus />;
    case 'comment-question':
      return <IconCommentQuestion />;
    case 'comment-redo':
      return <IconCommentRedo />;
    case 'comment-search':
      return <IconCommentSearch />;
    case 'comment-share':
      return <IconCommentShare />;
    case 'comment-shield':
      return <IconCommentShield />;
    case 'comment-slash':
      return <IconCommentSlash />;
    case 'comment-upload':
      return <IconCommentUpload />;
    case 'comment-verify':
      return <IconCommentVerify />;
    case 'comment':
      return <IconComment />;
    case 'comments-alt':
      return <IconCommentsAlt />;
    case 'comments':
      return <IconComments />;
    case 'compact-disc':
      return <IconCompactDisc />;
    case 'comparison':
      return <IconComparison />;
    case 'compass':
      return <IconCompass />;
    case 'compress-alt-left':
      return <IconCompressAltLeft />;
    case 'compress-alt':
      return <IconCompressAlt />;
    case 'compress-arrows':
      return <IconCompressArrows />;
    case 'compress-lines':
      return <IconCompressLines />;
    case 'compress-point':
      return <IconCompressPoint />;
    case 'compress-v':
      return <IconCompressV />;
    case 'compress':
      return <IconCompress />;
    case 'confused':
      return <IconConfused />;
    case 'constructor':
      return <IconConstructor />;
    case 'copy-alt':
      return <IconCopyAlt />;
    case 'copy-landscape':
      return <IconCopyLandscape />;
    case 'copy':
      return <IconCopy />;
    case 'copyright':
      return <IconCopyright />;
    case 'corner-down-left':
      return <IconCornerDownLeft />;
    case 'corner-down-right-alt':
      return <IconCornerDownRightAlt />;
    case 'corner-down-right':
      return <IconCornerDownRight />;
    case 'corner-left-down':
      return <IconCornerLeftDown />;
    case 'corner-right-down':
      return <IconCornerRightDown />;
    case 'corner-up-left-alt':
      return <IconCornerUpLeftAlt />;
    case 'corner-up-left':
      return <IconCornerUpLeft />;
    case 'corner-up-right-alt':
      return <IconCornerUpRightAlt />;
    case 'corner-up-right':
      return <IconCornerUpRight />;
    case 'coronavirus':
      return <IconCoronavirus />;
    case 'create-dashboard':
      return <IconCreateDashboard />;
    case 'creative-commons-pd':
      return <IconCreativeCommonsPd />;
    case 'credit-card-search':
      return <IconCreditCardSearch />;
    case 'credit-card':
      return <IconCreditCard />;
    case 'crockery':
      return <IconCrockery />;
    case 'crop-alt-rotate-left':
      return <IconCropAltRotateLeft />;
    case 'crop-alt-rotate-right':
      return <IconCropAltRotateRight />;
    case 'crop-alt':
      return <IconCropAlt />;
    case 'crosshair-alt':
      return <IconCrosshairAlt />;
    case 'crosshair':
      return <IconCrosshair />;
    case 'crosshairs':
      return <IconCrosshairs />;
    case 'css3-simple':
      return <IconCss3Simple />;
    case 'cube':
      return <IconCube />;
    case 'dashboard':
      return <IconDashboard />;
    case 'data-sharing':
      return <IconDataSharing />;
    case 'database-alt':
      return <IconDatabaseAlt />;
    case 'database':
      return <IconDatabase />;
    case 'desert':
      return <IconDesert />;
    case 'desktop-alt-slash':
      return <IconDesktopAltSlash />;
    case 'desktop-alt':
      return <IconDesktopAlt />;
    case 'desktop-cloud-alt':
      return <IconDesktopCloudAlt />;
    case 'desktop-slash':
      return <IconDesktopSlash />;
    case 'desktop':
      return <IconDesktop />;
    case 'dialpad-alt':
      return <IconDialpadAlt />;
    case 'dialpad':
      return <IconDialpad />;
    case 'diamond':
      return <IconDiamond />;
    case 'diary-alt':
      return <IconDiaryAlt />;
    case 'diary':
      return <IconDiary />;
    case 'dice-five':
      return <IconDiceFive />;
    case 'dice-four':
      return <IconDiceFour />;
    case 'dice-one':
      return <IconDiceOne />;
    case 'dice-six':
      return <IconDiceSix />;
    case 'dice-three':
      return <IconDiceThree />;
    case 'dice-two':
      return <IconDiceTwo />;
    case 'direction':
      return <IconDirection />;
    case 'directions':
      return <IconDirections />;
    case 'discord':
      return <IconDiscord />;
    case 'dizzy-meh':
      return <IconDizzyMeh />;
    case 'dna':
      return <IconDna />;
    case 'docker':
      return <IconDocker />;
    case 'document-info':
      return <IconDocumentInfo />;
    case 'document-layout-center':
      return <IconDocumentLayoutCenter />;
    case 'document-layout-left':
      return <IconDocumentLayoutLeft />;
    case 'document-layout-right':
      return <IconDocumentLayoutRight />;
    case 'dollar-alt':
      return <IconDollarAlt />;
    case 'dollar-sign-alt':
      return <IconDollarSignAlt />;
    case 'dollar-sign':
      return <IconDollarSign />;
    case 'download-alt':
      return <IconDownloadAlt />;
    case 'draggabledots':
      return <IconDraggabledots />;
    case 'dribbble':
      return <IconDribbble />;
    case 'drill':
      return <IconDrill />;
    case 'dropbox':
      return <IconDropbox />;
    case 'dumbbell':
      return <IconDumbbell />;
    case 'ear':
      return <IconEar />;
    case 'edit-alt':
      return <IconEditAlt />;
    case 'edit':
      return <IconEdit />;
    case 'elipsis-double-v-alt':
      return <IconElipsisDoubleVAlt />;
    case 'ellipsis-h':
      return <IconEllipsisH />;
    case 'ellipsis-v':
      return <IconEllipsisV />;
    case 'emoji':
      return <IconEmoji />;
    case 'english-to-chinese':
      return <IconEnglishToChinese />;
    case 'enter':
      return <IconEnter />;
    case 'envelope-add':
      return <IconEnvelopeAdd />;
    case 'envelope-alt':
      return <IconEnvelopeAlt />;
    case 'envelope-block':
      return <IconEnvelopeBlock />;
    case 'envelope-bookmark':
      return <IconEnvelopeBookmark />;
    case 'envelope-check':
      return <IconEnvelopeCheck />;
    case 'envelope-download-alt':
      return <IconEnvelopeDownloadAlt />;
    case 'envelope-download':
      return <IconEnvelopeDownload />;
    case 'envelope-edit':
      return <IconEnvelopeEdit />;
    case 'envelope-exclamation':
      return <IconEnvelopeExclamation />;
    case 'envelope-heart':
      return <IconEnvelopeHeart />;
    case 'envelope-info':
      return <IconEnvelopeInfo />;
    case 'envelope-lock':
      return <IconEnvelopeLock />;
    case 'envelope-minus':
      return <IconEnvelopeMinus />;
    case 'envelope-open':
      return <IconEnvelopeOpen />;
    case 'envelope-question':
      return <IconEnvelopeQuestion />;
    case 'envelope-receive':
      return <IconEnvelopeReceive />;
    case 'envelope-redo':
      return <IconEnvelopeRedo />;
    case 'envelope-search':
      return <IconEnvelopeSearch />;
    case 'envelope-send':
      return <IconEnvelopeSend />;
    case 'envelope-share':
      return <IconEnvelopeShare />;
    case 'envelope-shield':
      return <IconEnvelopeShield />;
    case 'envelope-star':
      return <IconEnvelopeStar />;
    case 'envelope-times':
      return <IconEnvelopeTimes />;
    case 'envelope-upload-alt':
      return <IconEnvelopeUploadAlt />;
    case 'envelope-upload':
      return <IconEnvelopeUpload />;
    case 'envelope':
      return <IconEnvelope />;
    case 'envelopes':
      return <IconEnvelopes />;
    case 'equal-circle':
      return <IconEqualCircle />;
    case 'estate':
      return <IconEstate />;
    case 'euro-circle':
      return <IconEuroCircle />;
    case 'euro':
      return <IconEuro />;
    case 'exchange-alt':
      return <IconExchangeAlt />;
    case 'exchange':
      return <IconExchange />;
    case 'exclamation-circle':
      return <IconExclamationCircle />;
    case 'exclamation-octagon':
      return <IconExclamationOctagon />;
    case 'exclamation-triangle':
      return <IconExclamationTriangle />;
    case 'exclamation':
      return <IconExclamation />;
    case 'exclude':
      return <IconExclude />;
    case 'exit':
      return <IconExit />;
    case 'expand-alt':
      return <IconExpandAlt />;
    case 'expand-arrows-alt':
      return <IconExpandArrowsAlt />;
    case 'expand-arrows':
      return <IconExpandArrows />;
    case 'expand-from-corner':
      return <IconExpandFromCorner />;
    case 'expand-left':
      return <IconExpandLeft />;
    case 'expand-right':
      return <IconExpandRight />;
    case 'export':
      return <IconExport />;
    case 'exposure-alt':
      return <IconExposureAlt />;
    case 'exposure-increase':
      return <IconExposureIncrease />;
    case 'external-link-alt':
      return <IconExternalLinkAlt />;
    case 'eye-slash':
      return <IconEyeSlash />;
    case 'eye':
      return <IconEye />;
    case 'facebook-f':
      return <IconFacebookF />;
    case 'facebook-messenger-alt':
      return <IconFacebookMessengerAlt />;
    case 'facebook-messenger':
      return <IconFacebookMessenger />;
    case 'facebook':
      return <IconFacebook />;
    case 'fahrenheit':
      return <IconFahrenheit />;
    case 'fast-mail-alt':
      return <IconFastMailAlt />;
    case 'fast-mail':
      return <IconFastMail />;
    case 'favorite':
      return <IconFavorite />;
    case 'feedback':
      return <IconFeedback />;
    case 'fidget-spinner':
      return <IconFidgetSpinner />;
    case 'file-alt':
      return <IconFileAlt />;
    case 'file-blank':
      return <IconFileBlank />;
    case 'file-block-alt':
      return <IconFileBlockAlt />;
    case 'file-bookmark-alt':
      return <IconFileBookmarkAlt />;
    case 'file-check-alt':
      return <IconFileCheckAlt />;
    case 'file-check':
      return <IconFileCheck />;
    case 'file-contract-dollar':
      return <IconFileContractDollar />;
    case 'file-contract':
      return <IconFileContract />;
    case 'file-copy-alt':
      return <IconFileCopyAlt />;
    case 'file-download-alt':
      return <IconFileDownloadAlt />;
    case 'file-download':
      return <IconFileDownload />;
    case 'file-edit-alt':
      return <IconFileEditAlt />;
    case 'file-exclamation-alt':
      return <IconFileExclamationAlt />;
    case 'file-exclamation':
      return <IconFileExclamation />;
    case 'file-export':
      return <IconFileExport />;
    case 'file-graph':
      return <IconFileGraph />;
    case 'file-heart':
      return <IconFileHeart />;
    case 'file-import':
      return <IconFileImport />;
    case 'file-info-alt':
      return <IconFileInfoAlt />;
    case 'file-landscape-alt':
      return <IconFileLandscapeAlt />;
    case 'file-landscape':
      return <IconFileLandscape />;
    case 'file-lanscape-slash':
      return <IconFileLanscapeSlash />;
    case 'file-lock-alt':
      return <IconFileLockAlt />;
    case 'file-medical-alt':
      return <IconFileMedicalAlt />;
    case 'file-medical':
      return <IconFileMedical />;
    case 'file-minus-alt':
      return <IconFileMinusAlt />;
    case 'file-minus':
      return <IconFileMinus />;
    case 'file-network':
      return <IconFileNetwork />;
    case 'file-plus-alt':
      return <IconFilePlusAlt />;
    case 'file-plus':
      return <IconFilePlus />;
    case 'file-question-alt':
      return <IconFileQuestionAlt />;
    case 'file-question':
      return <IconFileQuestion />;
    case 'file-redo-alt':
      return <IconFileRedoAlt />;
    case 'file-search-alt':
      return <IconFileSearchAlt />;
    case 'file-share-alt':
      return <IconFileShareAlt />;
    case 'file-shield-alt':
      return <IconFileShieldAlt />;
    case 'file-slash':
      return <IconFileSlash />;
    case 'file-times-alt':
      return <IconFileTimesAlt />;
    case 'file-times':
      return <IconFileTimes />;
    case 'file-upload-alt':
      return <IconFileUploadAlt />;
    case 'file-upload':
      return <IconFileUpload />;
    case 'file':
      return <IconFile />;
    case 'files-landscapes-alt':
      return <IconFilesLandscapesAlt />;
    case 'files-landscapes':
      return <IconFilesLandscapes />;
    case 'film':
      return <IconFilm />;
    case 'filter-slash':
      return <IconFilterSlash />;
    case 'filter':
      return <IconFilter />;
    case 'fire':
      return <IconFire />;
    case 'flask-potion':
      return <IconFlaskPotion />;
    case 'flask':
      return <IconFlask />;
    case 'flip-h-alt':
      return <IconFlipHAlt />;
    case 'flip-h':
      return <IconFlipH />;
    case 'flip-v-alt':
      return <IconFlipVAlt />;
    case 'flip-v':
      return <IconFlipV />;
    case 'flower':
      return <IconFlower />;
    case 'focus-add':
      return <IconFocusAdd />;
    case 'focus-target':
      return <IconFocusTarget />;
    case 'focus':
      return <IconFocus />;
    case 'folder-check':
      return <IconFolderCheck />;
    case 'folder-download':
      return <IconFolderDownload />;
    case 'folder-exclamation':
      return <IconFolderExclamation />;
    case 'folder-heart':
      return <IconFolderHeart />;
    case 'folder-info':
      return <IconFolderInfo />;
    case 'folder-lock':
      return <IconFolderLock />;
    case 'folder-medical':
      return <IconFolderMedical />;
    case 'folder-minus':
      return <IconFolderMinus />;
    case 'folder-network':
      return <IconFolderNetwork />;
    case 'folder-open':
      return <IconFolderOpen />;
    case 'folder-plus':
      return <IconFolderPlus />;
    case 'folder-question':
      return <IconFolderQuestion />;
    case 'folder-slash':
      return <IconFolderSlash />;
    case 'folder-times':
      return <IconFolderTimes />;
    case 'folder-upload':
      return <IconFolderUpload />;
    case 'folder':
      return <IconFolder />;
    case 'font':
      return <IconFont />;
    case 'football-american':
      return <IconFootballAmerican />;
    case 'football-ball':
      return <IconFootballBall />;
    case 'football':
      return <IconFootball />;
    case 'forecastcloud-moon-tear':
      return <IconForecastcloudMoonTear />;
    case 'forwaded-call':
      return <IconForwadedCall />;
    case 'forward':
      return <IconForward />;
    case 'frown':
      return <IconFrown />;
    case 'game-structure':
      return <IconGameStructure />;
    case 'gift':
      return <IconGift />;
    case 'github-alt':
      return <IconGithubAlt />;
    case 'github':
      return <IconGithub />;
    case 'gitlab':
      return <IconGitlab />;
    case 'glass-martini-alt-slash':
      return <IconGlassMartiniAltSlash />;
    case 'glass-martini-alt':
      return <IconGlassMartiniAlt />;
    case 'glass-martini':
      return <IconGlassMartini />;
    case 'glass-tea':
      return <IconGlassTea />;
    case 'glass':
      return <IconGlass />;
    case 'globe':
      return <IconGlobe />;
    case 'gold':
      return <IconGold />;
    case 'golf-ball':
      return <IconGolfBall />;
    case 'google-drive-alt':
      return <IconGoogleDriveAlt />;
    case 'google-drive':
      return <IconGoogleDrive />;
    case 'google-hangouts-alt':
      return <IconGoogleHangoutsAlt />;
    case 'google-hangouts':
      return <IconGoogleHangouts />;
    case 'google-play':
      return <IconGooglePlay />;
    case 'google':
      return <IconGoogle />;
    case 'graduation-cap':
      return <IconGraduationCap />;
    case 'graph-bar':
      return <IconGraphBar />;
    case 'grid':
      return <IconGrid />;
    case 'grids':
      return <IconGrids />;
    case 'grin-tongue-wink-alt':
      return <IconGrinTongueWinkAlt />;
    case 'grin-tongue-wink':
      return <IconGrinTongueWink />;
    case 'grin':
      return <IconGrin />;
    case 'grip-horizontal-line':
      return <IconGripHorizontalLine />;
    case 'hard-hat':
      return <IconHardHat />;
    case 'hdd':
      return <IconHdd />;
    case 'head-side-cough':
      return <IconHeadSideCough />;
    case 'head-side-mask':
      return <IconHeadSideMask />;
    case 'head-side':
      return <IconHeadSide />;
    case 'headphone-slash':
      return <IconHeadphoneSlash />;
    case 'headphones-alt':
      return <IconHeadphonesAlt />;
    case 'headphones':
      return <IconHeadphones />;
    case 'heart-alt':
      return <IconHeartAlt />;
    case 'heart-break':
      return <IconHeartBreak />;
    case 'heart-medical':
      return <IconHeartMedical />;
    case 'heart-rate':
      return <IconHeartRate />;
    case 'heart-sign':
      return <IconHeartSign />;
    case 'heart':
      return <IconHeart />;
    case 'heartbeat':
      return <IconHeartbeat />;
    case 'hindi-to-chinese':
      return <IconHindiToChinese />;
    case 'hipchat':
      return <IconHipchat />;
    case 'history-alt':
      return <IconHistoryAlt />;
    case 'history':
      return <IconHistory />;
    case 'home-alt':
      return <IconHomeAlt />;
    case 'home':
      return <IconHome />;
    case 'horizontal-align-center':
      return <IconHorizontalAlignCenter />;
    case 'horizontal-align-left':
      return <IconHorizontalAlignLeft />;
    case 'horizontal-align-right':
      return <IconHorizontalAlignRight />;
    case 'horizontal-distribution-center':
      return <IconHorizontalDistributionCenter />;
    case 'horizontal-distribution-left':
      return <IconHorizontalDistributionLeft />;
    case 'horizontal-distribution-right':
      return <IconHorizontalDistributionRight />;
    case 'hospital-square-sign':
      return <IconHospitalSquareSign />;
    case 'hospital-symbol':
      return <IconHospitalSymbol />;
    case 'hospital':
      return <IconHospital />;
    case 'hourglass':
      return <IconHourglass />;
    case 'house-user':
      return <IconHouseUser />;
    case 'html3-alt':
      return <IconHtml3Alt />;
    case 'html3':
      return <IconHtml3 />;
    case 'html5-alt':
      return <IconHtml5Alt />;
    case 'html5':
      return <IconHtml5 />;
    case 'hunting':
      return <IconHunting />;
    case 'icons':
      return <IconIcons />;
    case 'illustration':
      return <IconIllustration />;
    case 'image-alt-slash':
      return <IconImageAltSlash />;
    case 'image-block':
      return <IconImageBlock />;
    case 'image-broken':
      return <IconImageBroken />;
    case 'image-check':
      return <IconImageCheck />;
    case 'image-download':
      return <IconImageDownload />;
    case 'image-edit':
      return <IconImageEdit />;
    case 'image-lock':
      return <IconImageLock />;
    case 'image-minus':
      return <IconImageMinus />;
    case 'image-plus':
      return <IconImagePlus />;
    case 'image-question':
      return <IconImageQuestion />;
    case 'image-redo':
      return <IconImageRedo />;
    case 'image-resize-landscape':
      return <IconImageResizeLandscape />;
    case 'image-resize-square':
      return <IconImageResizeSquare />;
    case 'image-search':
      return <IconImageSearch />;
    case 'image-share':
      return <IconImageShare />;
    case 'image-shield':
      return <IconImageShield />;
    case 'image-slash':
      return <IconImageSlash />;
    case 'image-times':
      return <IconImageTimes />;
    case 'image-upload':
      return <IconImageUpload />;
    case 'image-v':
      return <IconImageV />;
    case 'image':
      return <IconImage />;
    case 'images':
      return <IconImages />;
    case 'import':
      return <IconImport />;
    case 'inbox':
      return <IconInbox />;
    case 'incoming-call':
      return <IconIncomingCall />;
    case 'info-circle':
      return <IconInfoCircle />;
    case 'info':
      return <IconInfo />;
    case 'instagram-alt':
      return <IconInstagramAlt />;
    case 'instagram':
      return <IconInstagram />;
    case 'intercom-alt':
      return <IconIntercomAlt />;
    case 'intercom':
      return <IconIntercom />;
    case 'invoice':
      return <IconInvoice />;
    case 'italic':
      return <IconItalic />;
    case 'jackhammer':
      return <IconJackhammer />;
    case 'java-script':
      return <IconJavaScript />;
    case 'kayak':
      return <IconKayak />;
    case 'key-skeleton-alt':
      return <IconKeySkeletonAlt />;
    case 'key-skeleton':
      return <IconKeySkeleton />;
    case 'keyboard-alt':
      return <IconKeyboardAlt />;
    case 'keyboard-hide':
      return <IconKeyboardHide />;
    case 'keyboard-show':
      return <IconKeyboardShow />;
    case 'keyboard':
      return <IconKeyboard />;
    case 'keyhole-circle':
      return <IconKeyholeCircle />;
    case 'keyhole-square-full':
      return <IconKeyholeSquareFull />;
    case 'keyhole-square':
      return <IconKeyholeSquare />;
    case 'kid':
      return <IconKid />;
    case 'label-alt':
      return <IconLabelAlt />;
    case 'label':
      return <IconLabel />;
    case 'lamp':
      return <IconLamp />;
    case 'language':
      return <IconLanguage />;
    case 'laptop-cloud':
      return <IconLaptopCloud />;
    case 'laptop-connection':
      return <IconLaptopConnection />;
    case 'laptop':
      return <IconLaptop />;
    case 'laughing':
      return <IconLaughing />;
    case 'layer-group-slash':
      return <IconLayerGroupSlash />;
    case 'layer-group':
      return <IconLayerGroup />;
    case 'layers-alt':
      return <IconLayersAlt />;
    case 'layers-slash':
      return <IconLayersSlash />;
    case 'layers':
      return <IconLayers />;
    case 'left-arrow-from-left':
      return <IconLeftArrowFromLeft />;
    case 'left-arrow-to-left':
      return <IconLeftArrowToLeft />;
    case 'left-indent-alt':
      return <IconLeftIndentAlt />;
    case 'left-indent':
      return <IconLeftIndent />;
    case 'left-to-right-text-direction':
      return <IconLeftToRightTextDirection />;
    case 'letter-chinese-a':
      return <IconLetterChineseA />;
    case 'letter-english-a':
      return <IconLetterEnglishA />;
    case 'letter-hindi-a':
      return <IconLetterHindiA />;
    case 'letter-japanese-a':
      return <IconLetterJapaneseA />;
    case 'life-ring':
      return <IconLifeRing />;
    case 'lightbulb-alt':
      return <IconLightbulbAlt />;
    case 'lightbulb':
      return <IconLightbulb />;
    case 'line-alt':
      return <IconLineAlt />;
    case 'line-spacing':
      return <IconLineSpacing />;
    case 'line':
      return <IconLine />;
    case 'link-add':
      return <IconLinkAdd />;
    case 'link-alt':
      return <IconLinkAlt />;
    case 'link-broken':
      return <IconLinkBroken />;
    case 'link-h':
      return <IconLinkH />;
    case 'link':
      return <IconLink />;
    case 'linkedin-alt':
      return <IconLinkedinAlt />;
    case 'linkedin':
      return <IconLinkedin />;
    case 'linux':
      return <IconLinux />;
    case 'lira-sign':
      return <IconLiraSign />;
    case 'list-ol-alt':
      return <IconListOlAlt />;
    case 'list-ol':
      return <IconListOl />;
    case 'list-ui-alt':
      return <IconListUiAlt />;
    case 'list-ul':
      return <IconListUl />;
    case 'location-arrow-alt':
      return <IconLocationArrowAlt />;
    case 'location-arrow':
      return <IconLocationArrow />;
    case 'location-pin-alt':
      return <IconLocationPinAlt />;
    case 'location-point':
      return <IconLocationPoint />;
    case 'lock-access':
      return <IconLockAccess />;
    case 'lock-alt':
      return <IconLockAlt />;
    case 'lock-open-alt':
      return <IconLockOpenAlt />;
    case 'lock-slash':
      return <IconLockSlash />;
    case 'lock':
      return <IconLock />;
    case 'lottiefiles-alt':
      return <IconLottiefilesAlt />;
    case 'lottiefiles':
      return <IconLottiefiles />;
    case 'luggage-cart':
      return <IconLuggageCart />;
    case 'mailbox-alt':
      return <IconMailboxAlt />;
    case 'mailbox':
      return <IconMailbox />;
    case 'map-marker-alt':
      return <IconMapMarkerAlt />;
    case 'map-marker-edit':
      return <IconMapMarkerEdit />;
    case 'map-marker-info':
      return <IconMapMarkerInfo />;
    case 'map-marker-minus':
      return <IconMapMarkerMinus />;
    case 'map-marker-plus':
      return <IconMapMarkerPlus />;
    case 'map-marker-question':
      return <IconMapMarkerQuestion />;
    case 'map-marker-shield':
      return <IconMapMarkerShield />;
    case 'map-marker-slash':
      return <IconMapMarkerSlash />;
    case 'map-marker':
      return <IconMapMarker />;
    case 'map-pin-alt':
      return <IconMapPinAlt />;
    case 'map-pin':
      return <IconMapPin />;
    case 'map':
      return <IconMap />;
    case 'mars':
      return <IconMars />;
    case 'master-card':
      return <IconMasterCard />;
    case 'maximize-left':
      return <IconMaximizeLeft />;
    case 'medal':
      return <IconMedal />;
    case 'medical-drip':
      return <IconMedicalDrip />;
    case 'medical-square-full':
      return <IconMedicalSquareFull />;
    case 'medical-square':
      return <IconMedicalSquare />;
    case 'medium-m':
      return <IconMediumM />;
    case 'medkit':
      return <IconMedkit />;
    case 'meeting-board':
      return <IconMeetingBoard />;
    case 'megaphone':
      return <IconMegaphone />;
    case 'meh-alt':
      return <IconMehAlt />;
    case 'meh-closed-eye':
      return <IconMehClosedEye />;
    case 'meh':
      return <IconMeh />;
    case 'message':
      return <IconMessage />;
    case 'metro':
      return <IconMetro />;
    case 'microphone-slash':
      return <IconMicrophoneSlash />;
    case 'microphone':
      return <IconMicrophone />;
    case 'microscope':
      return <IconMicroscope />;
    case 'microsoft':
      return <IconMicrosoft />;
    case 'minus-circle':
      return <IconMinusCircle />;
    case 'minus-path':
      return <IconMinusPath />;
    case 'minus-square-full':
      return <IconMinusSquareFull />;
    case 'minus-square':
      return <IconMinusSquare />;
    case 'minus':
      return <IconMinus />;
    case 'missed-call':
      return <IconMissedCall />;
    case 'mobile-android-alt':
      return <IconMobileAndroidAlt />;
    case 'mobile-android':
      return <IconMobileAndroid />;
    case 'mobile-vibrate':
      return <IconMobileVibrate />;
    case 'modem':
      return <IconModem />;
    case 'money-bill-slash':
      return <IconMoneyBillSlash />;
    case 'money-bill-stack':
      return <IconMoneyBillStack />;
    case 'money-bill':
      return <IconMoneyBill />;
    case 'money-insert':
      return <IconMoneyInsert />;
    case 'money-stack':
      return <IconMoneyStack />;
    case 'money-withdraw':
      return <IconMoneyWithdraw />;
    case 'money-withdrawal':
      return <IconMoneyWithdrawal />;
    case 'moneybag-alt':
      return <IconMoneybagAlt />;
    case 'moneybag':
      return <IconMoneybag />;
    case 'monitor-heart-rate':
      return <IconMonitorHeartRate />;
    case 'monitor':
      return <IconMonitor />;
    case 'moon-eclipse':
      return <IconMoonEclipse />;
    case 'moon':
      return <IconMoon />;
    case 'moonset':
      return <IconMoonset />;
    case 'motor':
      return <IconMotor />;
    case 'mountains-sun':
      return <IconMountainsSun />;
    case 'mountains':
      return <IconMountains />;
    case 'mouse-alt-2':
      return <IconMouseAlt2 />;
    case 'mouse-alt':
      return <IconMouseAlt />;
    case 'mouse':
      return <IconMouse />;
    case 'multiply':
      return <IconMultiply />;
    case 'music-note':
      return <IconMusicNote />;
    case 'music-tune-slash':
      return <IconMusicTuneSlash />;
    case 'music':
      return <IconMusic />;
    case 'n-a':
      return <IconNA />;
    case 'navigator':
      return <IconNavigator />;
    case 'nerd':
      return <IconNerd />;
    case 'newspaper':
      return <IconNewspaper />;
    case 'ninja':
      return <IconNinja />;
    case 'no-entry':
      return <IconNoEntry />;
    case 'notebooks':
      return <IconNotebooks />;
    case 'notes':
      return <IconNotes />;
    case 'object-group':
      return <IconObjectGroup />;
    case 'object-ungroup':
      return <IconObjectUngroup />;
    case 'octagon':
      return <IconOctagon />;
    case 'okta':
      return <IconOkta />;
    case 'opera-alt':
      return <IconOperaAlt />;
    case 'opera':
      return <IconOpera />;
    case 'outgoing-call':
      return <IconOutgoingCall />;
    case 'package':
      return <IconPackage />;
    case 'padlock':
      return <IconPadlock />;
    case 'pagelines':
      return <IconPagelines />;
    case 'pagerduty':
      return <IconPagerduty />;
    case 'paint-tool':
      return <IconPaintTool />;
    case 'palette':
      return <IconPalette />;
    case 'panel-add':
      return <IconPanelAdd />;
    case 'panorama-h-alt':
      return <IconPanoramaHAlt />;
    case 'panorama-h':
      return <IconPanoramaH />;
    case 'panorama-v':
      return <IconPanoramaV />;
    case 'paperclip':
      return <IconPaperclip />;
    case 'paragraph':
      return <IconParagraph />;
    case 'parcel':
      return <IconParcel />;
    case 'parking-circle':
      return <IconParkingCircle />;
    case 'parking-square':
      return <IconParkingSquare />;
    case 'pathfinder-unite':
      return <IconPathfinderUnite />;
    case 'pathfinder':
      return <IconPathfinder />;
    case 'pause-circle':
      return <IconPauseCircle />;
    case 'pause':
      return <IconPause />;
    case 'paypal':
      return <IconPaypal />;
    case 'pen':
      return <IconPen />;
    case 'pentagon':
      return <IconPentagon />;
    case 'percentage':
      return <IconPercentage />;
    case 'phone-alt':
      return <IconPhoneAlt />;
    case 'phone-pause':
      return <IconPhonePause />;
    case 'phone-slash':
      return <IconPhoneSlash />;
    case 'phone-times':
      return <IconPhoneTimes />;
    case 'phone-volume':
      return <IconPhoneVolume />;
    case 'phone':
      return <IconPhone />;
    case 'picture':
      return <IconPicture />;
    case 'pizza-slice':
      return <IconPizzaSlice />;
    case 'plane-arrival':
      return <IconPlaneArrival />;
    case 'plane-departure':
      return <IconPlaneDeparture />;
    case 'plane-fly':
      return <IconPlaneFly />;
    case 'plane':
      return <IconPlane />;
    case 'play-circle':
      return <IconPlayCircle />;
    case 'play':
      return <IconPlay />;
    case 'plug':
      return <IconPlug />;
    case 'plus-circle':
      return <IconPlusCircle />;
    case 'plus-square':
      return <IconPlusSquare />;
    case 'plus':
      return <IconPlus />;
    case 'podium':
      return <IconPodium />;
    case 'polygon':
      return <IconPolygon />;
    case 'post-stamp':
      return <IconPostStamp />;
    case 'postcard':
      return <IconPostcard />;
    case 'pound-circle':
      return <IconPoundCircle />;
    case 'pound':
      return <IconPound />;
    case 'power':
      return <IconPower />;
    case 'prescription-bottle':
      return <IconPrescriptionBottle />;
    case 'presentation-check':
      return <IconPresentationCheck />;
    case 'presentation-edit':
      return <IconPresentationEdit />;
    case 'presentation-line':
      return <IconPresentationLine />;
    case 'presentation-lines-alt':
      return <IconPresentationLinesAlt />;
    case 'presentation-minus':
      return <IconPresentationMinus />;
    case 'presentation-play':
      return <IconPresentationPlay />;
    case 'presentation-plus':
      return <IconPresentationPlus />;
    case 'presentation-times':
      return <IconPresentationTimes />;
    case 'presentation':
      return <IconPresentation />;
    case 'previous':
      return <IconPrevious />;
    case 'pricetag-alt':
      return <IconPricetagAlt />;
    case 'print-slash':
      return <IconPrintSlash />;
    case 'print':
      return <IconPrint />;
    case 'process':
      return <IconProcess />;
    case 'processor':
      return <IconProcessor />;
    case 'programming-language':
      return <IconProgrammingLanguage />;
    case 'pump':
      return <IconPump />;
    case 'puzzle-piece':
      return <IconPuzzlePiece />;
    case 'qrcode-scan':
      return <IconQrcodeScan />;
    case 'question-circle':
      return <IconQuestionCircle />;
    case 'question':
      return <IconQuestion />;
    case 'rainbow':
      return <IconRainbow />;
    case 'raindrops-alt':
      return <IconRaindropsAlt />;
    case 'raindrops':
      return <IconRaindrops />;
    case 'react':
      return <IconReact />;
    case 'receipt-alt':
      return <IconReceiptAlt />;
    case 'receipt':
      return <IconReceipt />;
    case 'record-audio':
      return <IconRecordAudio />;
    case 'reddit-alien-alt':
      return <IconRedditAlienAlt />;
    case 'redo':
      return <IconRedo />;
    case 'refresh':
      return <IconRefresh />;
    case 'registered':
      return <IconRegistered />;
    case 'repeat':
      return <IconRepeat />;
    case 'restaurant':
      return <IconRestaurant />;
    case 'right-indent-alt':
      return <IconRightIndentAlt />;
    case 'right-to-left-text-direction':
      return <IconRightToLeftTextDirection />;
    case 'robot':
      return <IconRobot />;
    case 'rocket':
      return <IconRocket />;
    case 'rope-way':
      return <IconRopeWay />;
    case 'rotate-360':
      return <IconRotate360 />;
    case 'rss-alt':
      return <IconRssAlt />;
    case 'rss-interface':
      return <IconRssInterface />;
    case 'rss':
      return <IconRss />;
    case 'ruler-combined':
      return <IconRulerCombined />;
    case 'ruler':
      return <IconRuler />;
    case 'rupee-sign':
      return <IconRupeeSign />;
    case 'sad-cry':
      return <IconSadCry />;
    case 'sad-crying':
      return <IconSadCrying />;
    case 'sad-dizzy':
      return <IconSadDizzy />;
    case 'sad-squint':
      return <IconSadSquint />;
    case 'sad':
      return <IconSad />;
    case 'sanitizer-alt':
      return <IconSanitizerAlt />;
    case 'sanitizer':
      return <IconSanitizer />;
    case 'save':
      return <IconSave />;
    case 'scaling-left':
      return <IconScalingLeft />;
    case 'scaling-right':
      return <IconScalingRight />;
    case 'scenery':
      return <IconScenery />;
    case 'schedule':
      return <IconSchedule />;
    case 'screw':
      return <IconScrew />;
    case 'scroll-h':
      return <IconScrollH />;
    case 'scroll':
      return <IconScroll />;
    case 'search-alt':
      return <IconSearchAlt />;
    case 'search-minus':
      return <IconSearchMinus />;
    case 'search-plus':
      return <IconSearchPlus />;
    case 'search':
      return <IconSearch />;
    case 'selfie':
      return <IconSelfie />;
    case 'server-alt':
      return <IconServerAlt />;
    case 'server-connection':
      return <IconServerConnection />;
    case 'server-network-alt':
      return <IconServerNetworkAlt />;
    case 'server-network':
      return <IconServerNetwork />;
    case 'server':
      return <IconServer />;
    case 'servers':
      return <IconServers />;
    case 'servicemark':
      return <IconServicemark />;
    case 'setting':
      return <IconSetting />;
    case 'share-alt':
      return <IconShareAlt />;
    case 'share':
      return <IconShare />;
    case 'shield-check':
      return <IconShieldCheck />;
    case 'shield-exclamation':
      return <IconShieldExclamation />;
    case 'shield-plus':
      return <IconShieldPlus />;
    case 'shield-question':
      return <IconShieldQuestion />;
    case 'shield-slash':
      return <IconShieldSlash />;
    case 'shield':
      return <IconShield />;
    case 'ship':
      return <IconShip />;
    case 'shop':
      return <IconShop />;
    case 'shopping-bag':
      return <IconShoppingBag />;
    case 'shopping-basket':
      return <IconShoppingBasket />;
    case 'shopping-cart-alt':
      return <IconShoppingCartAlt />;
    case 'shopping-cart':
      return <IconShoppingCart />;
    case 'shovel':
      return <IconShovel />;
    case 'shrink':
      return <IconShrink />;
    case 'shuffle':
      return <IconShuffle />;
    case 'shutter-alt':
      return <IconShutterAlt />;
    case 'shutter':
      return <IconShutter />;
    case 'sick':
      return <IconSick />;
    case 'sigma':
      return <IconSigma />;
    case 'sign-alt':
      return <IconSignAlt />;
    case 'sign-in-alt':
      return <IconSignInAlt />;
    case 'sign-left':
      return <IconSignLeft />;
    case 'sign-out-alt':
      return <IconSignOutAlt />;
    case 'sign-right':
      return <IconSignRight />;
    case 'signal-alt-3':
      return <IconSignalAlt3 />;
    case 'signal-alt':
      return <IconSignalAlt />;
    case 'signal':
      return <IconSignal />;
    case 'signin':
      return <IconSignin />;
    case 'signout':
      return <IconSignout />;
    case 'silence':
      return <IconSilence />;
    case 'silent-squint':
      return <IconSilentSquint />;
    case 'sim-card':
      return <IconSimCard />;
    case 'sitemap':
      return <IconSitemap />;
    case 'skip-forward-alt':
      return <IconSkipForwardAlt />;
    case 'skip-forward-circle':
      return <IconSkipForwardCircle />;
    case 'skip-forward':
      return <IconSkipForward />;
    case 'skype-alt':
      return <IconSkypeAlt />;
    case 'skype':
      return <IconSkype />;
    case 'slack-alt':
      return <IconSlackAlt />;
    case 'slack':
      return <IconSlack />;
    case 'slider-h-range':
      return <IconSliderHRange />;
    case 'slider-h':
      return <IconSliderH />;
    case 'sliders-v-alt':
      return <IconSlidersVAlt />;
    case 'sliders-v':
      return <IconSlidersV />;
    case 'smile-beam':
      return <IconSmileBeam />;
    case 'smile-dizzy':
      return <IconSmileDizzy />;
    case 'smile-squint-wink-alt':
      return <IconSmileSquintWinkAlt />;
    case 'smile-squint-wink':
      return <IconSmileSquintWink />;
    case 'smile-wink-alt':
      return <IconSmileWinkAlt />;
    case 'smile-wink':
      return <IconSmileWink />;
    case 'smile':
      return <IconSmile />;
    case 'snapchat-alt':
      return <IconSnapchatAlt />;
    case 'snapchat-ghost':
      return <IconSnapchatGhost />;
    case 'snapchat-square':
      return <IconSnapchatSquare />;
    case 'snow-flake':
      return <IconSnowFlake />;
    case 'snowflake-alt':
      return <IconSnowflakeAlt />;
    case 'social-distancing':
      return <IconSocialDistancing />;
    case 'sort-amount-down':
      return <IconSortAmountDown />;
    case 'sort-amount-up':
      return <IconSortAmountUp />;
    case 'sort':
      return <IconSort />;
    case 'sorting':
      return <IconSorting />;
    case 'space-key':
      return <IconSpaceKey />;
    case 'spade':
      return <IconSpade />;
    case 'sperms':
      return <IconSperms />;
    case 'spin':
      return <IconSpin />;
    case 'spinner-alt':
      return <IconSpinnerAlt />;
    case 'spinner':
      return <IconSpinner />;
    case 'square-full':
      return <IconSquareFull />;
    case 'square-shape':
      return <IconSquareShape />;
    case 'square':
      return <IconSquare />;
    case 'squint':
      return <IconSquint />;
    case 'star-half-alt':
      return <IconStarHalfAlt />;
    case 'star':
      return <IconStar />;
    case 'step-backward-alt':
      return <IconStepBackwardAlt />;
    case 'step-backward-circle':
      return <IconStepBackwardCircle />;
    case 'step-backward':
      return <IconStepBackward />;
    case 'step-forward':
      return <IconStepForward />;
    case 'stethoscope-alt':
      return <IconStethoscopeAlt />;
    case 'stethoscope':
      return <IconStethoscope />;
    case 'stop-circle':
      return <IconStopCircle />;
    case 'stopwatch-slash':
      return <IconStopwatchSlash />;
    case 'stopwatch':
      return <IconStopwatch />;
    case 'store-alt':
      return <IconStoreAlt />;
    case 'store-slash':
      return <IconStoreSlash />;
    case 'store':
      return <IconStore />;
    case 'streering':
      return <IconStreering />;
    case 'stretcher':
      return <IconStretcher />;
    case 'subject':
      return <IconSubject />;
    case 'subway-alt':
      return <IconSubwayAlt />;
    case 'subway':
      return <IconSubway />;
    case 'suitcase-alt':
      return <IconSuitcaseAlt />;
    case 'suitcase':
      return <IconSuitcase />;
    case 'sun':
      return <IconSun />;
    case 'sunset':
      return <IconSunset />;
    case 'surprise':
      return <IconSurprise />;
    case 'swatchbook':
      return <IconSwatchbook />;
    case 'swiggy':
      return <IconSwiggy />;
    case 'swimmer':
      return <IconSwimmer />;
    case 'sync-exclamation':
      return <IconSyncExclamation />;
    case 'sync-slash':
      return <IconSyncSlash />;
    case 'sync':
      return <IconSync />;
    case 'syringe':
      return <IconSyringe />;
    case 'table-tennis':
      return <IconTableTennis />;
    case 'table':
      return <IconTable />;
    case 'tablet':
      return <IconTablet />;
    case 'tablets':
      return <IconTablets />;
    case 'tachometer-fast-alt':
      return <IconTachometerFastAlt />;
    case 'tachometer-fast':
      return <IconTachometerFast />;
    case 'tag-alt':
      return <IconTagAlt />;
    case 'tag':
      return <IconTag />;
    case 'tape':
      return <IconTape />;
    case 'taxi':
      return <IconTaxi />;
    case 'tear':
      return <IconTear />;
    case 'telegram-alt':
      return <IconTelegramAlt />;
    case 'telegram':
      return <IconTelegram />;
    case 'telescope':
      return <IconTelescope />;
    case 'temperature-empty':
      return <IconTemperatureEmpty />;
    case 'temperature-half':
      return <IconTemperatureHalf />;
    case 'temperature-minus':
      return <IconTemperatureMinus />;
    case 'temperature-plus':
      return <IconTemperaturePlus />;
    case 'temperature-quarter':
      return <IconTemperatureQuarter />;
    case 'temperature-three-quarter':
      return <IconTemperatureThreeQuarter />;
    case 'temperature':
      return <IconTemperature />;
    case 'tennis-ball':
      return <IconTennisBall />;
    case 'text-fields':
      return <IconTextFields />;
    case 'text-size':
      return <IconTextSize />;
    case 'text-strike-through':
      return <IconTextStrikeThrough />;
    case 'text':
      return <IconText />;
    case 'th-large':
      return <IconThLarge />;
    case 'th-slash':
      return <IconThSlash />;
    case 'th':
      return <IconTh />;
    case 'thermometer':
      return <IconThermometer />;
    case 'thumbs-down':
      return <IconThumbsDown />;
    case 'thumbs-up':
      return <IconThumbsUp />;
    case 'thunderstorm-moon':
      return <IconThunderstormMoon />;
    case 'thunderstorm-sun':
      return <IconThunderstormSun />;
    case 'thunderstorm':
      return <IconThunderstorm />;
    case 'ticket':
      return <IconTicket />;
    case 'times-circle':
      return <IconTimesCircle />;
    case 'times-square':
      return <IconTimesSquare />;
    case 'times':
      return <IconTimes />;
    case 'toggle-off':
      return <IconToggleOff />;
    case 'toggle-on':
      return <IconToggleOn />;
    case 'toilet-paper':
      return <IconToiletPaper />;
    case 'top-arrow-from-top':
      return <IconTopArrowFromTop />;
    case 'top-arrow-to-top':
      return <IconTopArrowToTop />;
    case 'tornado':
      return <IconTornado />;
    case 'trademark-circle':
      return <IconTrademarkCircle />;
    case 'trademark':
      return <IconTrademark />;
    case 'traffic-barrier':
      return <IconTrafficBarrier />;
    case 'traffic-light':
      return <IconTrafficLight />;
    case 'transaction':
      return <IconTransaction />;
    case 'trash-alt':
      return <IconTrashAlt />;
    case 'trash':
      return <IconTrash />;
    case 'trees':
      return <IconTrees />;
    case 'triangle':
      return <IconTriangle />;
    case 'trophy':
      return <IconTrophy />;
    case 'trowel':
      return <IconTrowel />;
    case 'truck-loading':
      return <IconTruckLoading />;
    case 'truck':
      return <IconTruck />;
    case 'tumblr-alt':
      return <IconTumblrAlt />;
    case 'tumblr-square':
      return <IconTumblrSquare />;
    case 'tumblr':
      return <IconTumblr />;
    case 'tv-retro-slash':
      return <IconTvRetroSlash />;
    case 'tv-retro':
      return <IconTvRetro />;
    case 'twitter-alt':
      return <IconTwitterAlt />;
    case 'twitter':
      return <IconTwitter />;
    case 'umbrella':
      return <IconUmbrella />;
    case 'unamused':
      return <IconUnamused />;
    case 'underline':
      return <IconUnderline />;
    case 'university':
      return <IconUniversity />;
    case 'unlock-alt':
      return <IconUnlockAlt />;
    case 'unlock':
      return <IconUnlock />;
    case 'upload-alt':
      return <IconUploadAlt />;
    case 'upload':
      return <IconUpload />;
    case 'usd-circle':
      return <IconUsdCircle />;
    case 'usd-square':
      return <IconUsdSquare />;
    case 'user-arrows':
      return <IconUserArrows />;
    case 'user-check':
      return <IconUserCheck />;
    case 'user-circle':
      return <IconUserCircle />;
    case 'user-exclamation':
      return <IconUserExclamation />;
    case 'user-location':
      return <IconUserLocation />;
    case 'user-md':
      return <IconUserMd />;
    case 'user-minus':
      return <IconUserMinus />;
    case 'user-nurse':
      return <IconUserNurse />;
    case 'user-plus':
      return <IconUserPlus />;
    case 'user-square':
      return <IconUserSquare />;
    case 'user-times':
      return <IconUserTimes />;
    case 'user':
      return <IconUser />;
    case 'users-alt':
      return <IconUsersAlt />;
    case 'utensils-alt':
      return <IconUtensilsAlt />;
    case 'utensils':
      return <IconUtensils />;
    case 'vector-square-alt':
      return <IconVectorSquareAlt />;
    case 'vector-square':
      return <IconVectorSquare />;
    case 'venus':
      return <IconVenus />;
    case 'vertical-align-bottom':
      return <IconVerticalAlignBottom />;
    case 'vertical-align-center':
      return <IconVerticalAlignCenter />;
    case 'vertical-align-top':
      return <IconVerticalAlignTop />;
    case 'vertical-distribute-bottom':
      return <IconVerticalDistributeBottom />;
    case 'vertical-distribution-center':
      return <IconVerticalDistributionCenter />;
    case 'vertical-distribution-top':
      return <IconVerticalDistributionTop />;
    case 'video-question':
      return <IconVideoQuestion />;
    case 'video-slash':
      return <IconVideoSlash />;
    case 'video':
      return <IconVideo />;
    case 'virus-slash':
      return <IconVirusSlash />;
    case 'visual-studio':
      return <IconVisualStudio />;
    case 'vk-alt':
      return <IconVkAlt />;
    case 'vk':
      return <IconVk />;
    case 'voicemail-rectangle':
      return <IconVoicemailRectangle />;
    case 'voicemail':
      return <IconVoicemail />;
    case 'volleyball':
      return <IconVolleyball />;
    case 'volume-down':
      return <IconVolumeDown />;
    case 'volume-mute':
      return <IconVolumeMute />;
    case 'volume-off':
      return <IconVolumeOff />;
    case 'volume-up':
      return <IconVolumeUp />;
    case 'volume':
      return <IconVolume />;
    case 'vuejs-alt':
      return <IconVuejsAlt />;
    case 'vuejs':
      return <IconVuejs />;
    case 'wall':
      return <IconWall />;
    case 'wallet':
      return <IconWallet />;
    case 'watch-alt':
      return <IconWatchAlt />;
    case 'watch':
      return <IconWatch />;
    case 'water-drop-slash':
      return <IconWaterDropSlash />;
    case 'water-glass':
      return <IconWaterGlass />;
    case 'water':
      return <IconWater />;
    case 'web-grid-alt':
      return <IconWebGridAlt />;
    case 'web-grid':
      return <IconWebGrid />;
    case 'web-section-alt':
      return <IconWebSectionAlt />;
    case 'web-section':
      return <IconWebSection />;
    case 'webcam':
      return <IconWebcam />;
    case 'weight':
      return <IconWeight />;
    case 'whatsapp-alt':
      return <IconWhatsappAlt />;
    case 'whatsapp':
      return <IconWhatsapp />;
    case 'wheel-barrow':
      return <IconWheelBarrow />;
    case 'wheelchair-alt':
      return <IconWheelchairAlt />;
    case 'wheelchair':
      return <IconWheelchair />;
    case 'wifi-router':
      return <IconWifiRouter />;
    case 'wifi-slash':
      return <IconWifiSlash />;
    case 'wifi':
      return <IconWifi />;
    case 'wind-moon':
      return <IconWindMoon />;
    case 'wind-sun':
      return <IconWindSun />;
    case 'wind':
      return <IconWind />;
    case 'window-grid':
      return <IconWindowGrid />;
    case 'window-maximize':
      return <IconWindowMaximize />;
    case 'window-section':
      return <IconWindowSection />;
    case 'window':
      return <IconWindow />;
    case 'windows':
      return <IconWindows />;
    case 'windsock':
      return <IconWindsock />;
    case 'windy':
      return <IconWindy />;
    case 'wordpress-simple':
      return <IconWordpressSimple />;
    case 'wordpress':
      return <IconWordpress />;
    case 'wrap-text':
      return <IconWrapText />;
    case 'wrench':
      return <IconWrench />;
    case 'x-add':
      return <IconXAdd />;
    case 'x':
      return <IconX />;
    case 'yen-circle':
      return <IconYenCircle />;
    case 'yen':
      return <IconYen />;
    case 'yin-yang':
      return <IconYinYang />;
    case 'youtube':
      return <IconYoutube />;
    default:
      return <></>;
  }
}
